import {
	ClientActivityTypeEnum,
	ClientBondInterestTypeEnum,
	ClientCarBodyTypeEnum,
	ClientCarFuelEnum,
	ClientEventTypeEnum,
	ClientFinancialPlanExpenseNameEnum,
	ClientFinancialPlanExpenseTypeEnum,
	ClientIdentificationDocumentTypeEnum,
	ClientPortfolioDataCommodityServiceEnum,
	ClientPortfolioDomainEnum,
	ClientPortfolioInstructionHoldingTypeEnum,
	ClientPortfolioInsuredPersonRiskEnum,
	ClientPortfolioInvestmentEnterFeeAmountTypeEnum,
	ClientPortfolioInvestmentEnterFeeApplyingEnum,
	ClientPortfolioInvestmentEnterFeeTypeEnum,
	ClientPortfolioInvestmentFrequencyEnum,
	ClientPortfolioInvestmentTransactionEnum,
	ClientPortfolioInvestmentTypeEnum,
	ClientPortfolioPaymentFrequencyEnum,
	ClientPortfolioToolIdentificationTypeEnum,
	ClientPortfolioToolTypeEnum,
	ClientPropertyBuildingDispositionEnum,
	ClientPropertyBuildingMaterialEnum,
	ClientPropertyCarVehicleTypeEnum,
	ClientPropertyCategoryEnum,
	ClientPropertyOwnershipEnum,
	ClientPropertyRenovationEnum,
	ClientPropertyTypeEnum,
	ClientPropertyVehicleTypeEnum,
	CurrencyEnum,
	UserTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import type { MyPlannResourceDictionary } from "web_myplann/Infrastructure/Translations/ResourceDictionary";
import { EventClassificationEnum } from "web_myplann/NotificationCenter/EventAlert/types";
import czechZodTranslations from "zod-i18n-map/locales/cs/zod.json";

export const MyPlannCzechResourcesDictionary: MyPlannResourceDictionary = {
	Common: {
		AppName: "myPLANN",
		CurrencySign: "Kč",
		ValueNotProvided: "Hodnota neuvedena",
		ValueNotProvidedSubtitle: "Pokud hodnotu znáte, sdělte ji svému poradci.",
		contact: "Kontakt",
		LoadMore: "Načíst starší",
		save: "Uložit",
		continue: "Pokračovat",
		ShowMore: "Zobrazit vše",
		Send: "Poslat",
		Search: "Vyhledat",
		Filter: "Filtrovat",
		Apply: "Potvrdit",
		Select: "Vybrat",
		Name: "Název",
		FirstName: "Jméno",
		NoData: "Žádná data",
		ToDate: "K datu",
		Min: "Minimální",
		Max: "Maximální",
		solvedEvents: "Právě řešíme",
		upcomingEvents: "Blížící se události",
		overdueEvents: "Uplynulé události",
		resolvedEvents: "Uzavřené aktivity",
		DisplayAll: "Zobrazit vše",
		Hide: "Skrýt",
		LoadNext: "Načíst další",
		OneDocument: "dokument",
		FewDocuments: "dokumenty",
		MoreDocuments: "dokumentů",
		NoDocuments: "Žádné dokumenty",
		NotSpecified: "Neurčito",
		DatePicker: {
			previousYear: "Předchozí rok",
			nextYear: "Následující rok",
			previousMonth: "Předchozí měsíc",
			nextMonth: "Následující měsíc",
			previousDecade: "Předchozí desetiletí",
			nextDecade: "Následující desetiletí",
			chooseMonthAndYear: "{{title}}, vybrat měsíc a rok",
			chooseYear: "Rok {{year}}, vybrat rok",
		},
		ToolbarMenu: {
			WritteMessage: "Napsat zprávu",
			Call: "Volat",
			WriteSMS: "Napsat SMS",
			WriteEmail: "Napsat E-mail",
		},
		somethingWentWrong: "Něco se nepovedlo, kontaktujte svého poradce",
		unknownError: "Neznámá chyba",
		documentOpenFailed: "Dokument se nepodařilo otevřít.",
		Cancel: "Zrušit",
		Confirm: "Potvrdit",
		yes: "Ano",
		no: "Ne",
		ListBar: {
			itemsCount: "{{count}} položek",
			itemsCount_one: "{{count}} položka",
			itemsCount_few: "{{count}} položky",
			itemsCount_other: "{{count}} položek",
			filterChip: "Filtr",
			filterChipActive: "Filtr ({{summary}})",
		},
	},
	Errors: {
		ApplicationError: {
			Home: "Domů",
			title: "Něco se pokazilo",
			description:
				"Stránku se nepodařilo zobrazit. Zkuste to prosím znovu, nebo se vraťte na úvod.",
			retry: "Zkusit znovu",
			devDetails: "Detail chyby",
		},
		Error404: {
			Home: "Domů",
			Subtitle: "Stránka nebyla nalezena",
		},
	},
	zod: czechZodTranslations,
	Profile: {
		title: "Profil",
		V2: {
			title: "Můj profil",
		},
		MissingAdvisor: {
			title: "Nemáte přiřazeného poradce",
			description:
				"Vaše aplikace nemá odkud načíst data. Kontaktujte prosím svého poradce.",
			logOut: "Odhlásit se",
		},
		Fields: {
			phone: "Telefon",
			email: "E-mail",
		},
		Overview: {
			toolsSection: "Nástroje",
		},
		Sections: {
			PersonalDataAndAccounts: "Osobní údaje a účty",
			Addresses: "Adresy",
			Paperwork: "Doklady",
			FinancialBalance: "Finanční bilance",
		},
		EmptyList: {
			Addresses: {
				label: "Žádné adresy",
				description: "Zde uvidíte všechny své adresy.",
			},
			Paperwork: {
				label: "Žádné doklady",
				description: "Zde uvidíte všechny své doklady.",
			},
		},
	},
	PersonalDataAndAccounts: {
		title: "Osobní údaje a účty",
		PersonalData: {
			title: "Osobní údaje",
			Name: "Jméno",
			Surname: "Příjmení",
			BirthNumber: "Rodné číslo",
			BirthDate: "Datum narození",
			BirthPlace: "Místo narození",
			MaritalStatus: "Rodinný stav",
			HealthInsurance: "Zdravotní pojišťovna",
		},
	},
	Addresses: {
		title: "Adresy",
		Type: {
			permanent: "Trvalá/Sídlo",
			contact: "Kontaktní",
		},
		PermanentAddress: {
			title: "Trvalá adresa",
			Street: "Ulice",
			StreetNumber: "Číslo popis. a orient.",
			City: "Město",
			Zip: "PSČ",
			Country: "Země",
		},
		ContactAddress: {
			title: "Kontaktní adresa",
			Street: "Ulice",
			StreetNumber: "Číslo popis. a orient.",
			City: "Město",
			Zip: "PSČ",
			Country: "Země",
		},
	},
	Reminder: {
		title: "Připomenutí",
		add: "Přidat připomenutí",
		quickChoice: "Rychlá volba",
		date: "Datum",
		selectDate: "Vybrat datum",
		recurrence: "Opakování",
		until: "do {{date}}",
		Recurrence: {
			once: "Jednorázově",
			yearly: "Každý rok",
			twoYears: "Každé 2 roky",
			fourYears: "Každé 4 roky",
		},
		Presets: {
			monthBefore: "Měsíc před vypršením",
			threeMonthsBefore: "3 měsíce před",
			onExpiry: "V den vypršení",
		},
	},
	Paperwork: {
		title: "Moje doklady",
		Types: {
			[ClientIdentificationDocumentTypeEnum.Passport]: "Cestovní pas",
			[ClientIdentificationDocumentTypeEnum.IdentityCard]: "Občanský průkaz",
			[ClientIdentificationDocumentTypeEnum.WeaponLicense]: "Zbrojní průkaz",
			[ClientIdentificationDocumentTypeEnum.STK]: "Protokol STK",
			[ClientIdentificationDocumentTypeEnum.DrivingLicense]: "Řidičský průkaz",
			[ClientIdentificationDocumentTypeEnum.FishingLicense]: "Rybářský lístek",
			[ClientIdentificationDocumentTypeEnum.HuntingLicense]: "Lovecký lístek",
			[ClientIdentificationDocumentTypeEnum.ISIC]: "Průkaz ISIC",
			[ClientIdentificationDocumentTypeEnum.InsuranceCard]:
				"Kartička pojištěnce",
			[ClientIdentificationDocumentTypeEnum.Other]: "Jiný doklad",
			[ClientIdentificationDocumentTypeEnum.PilotLicense]: "Pilotní průkaz",
			[ClientIdentificationDocumentTypeEnum.ResidencePermit]:
				"Povolení k pobytu",
			[ClientIdentificationDocumentTypeEnum.ShipLicense]:
				"Průkaz vůdce plavidla",
			[ClientIdentificationDocumentTypeEnum.TravelLicense]: "Cestovní průkaz",
		},
		DocumentNumber: "Číslo dokladu",
		ExpirationDate: "Platnost dokladu",
		uploadedSection: "Nahrané doklady",
		numberPrefix: "č.",
		addDocument: "Přidat další doklad",
		infoNote:
			"Doklady jsou uloženy šifrovaně a přístupné pouze vám a vašemu poradci. Systém vás upozorní před vypršením platnosti.",
		Validity: {
			until: "do {{date}}",
			noExpiration: "Bez expirace",
		},
		Detail: {
			type: "Typ dokladu",
			number: "Číslo dokladu",
			issuer: "Vydal",
			validTo: "Platnost do",
			Status: {
				valid: "Platný",
				expiring: "Brzy vyprší",
				expired: "Expirovaný",
				none: "Bez expirace",
			},
			Actions: {
				title: "Akce",
				update: "Aktualizovat doklad",
				updateHint: "Upravit údaje dokladu",
				delete: "Smazat doklad",
			},
			DeleteConfirm: {
				title: "Smazat doklad?",
				description: "Doklad bude trvale odstraněn. Tuto akci nelze vrátit.",
				confirm: "Smazat",
				cancel: "Zrušit",
			},
			Error: {
				title: "Doklady se nepodařilo načíst",
				description: "Zkontrolujte připojení k internetu a zkuste to znovu.",
				retry: "Zkusit znovu",
			},
		},
		Upload: {
			title: "Přidat doklad",
			updateTitle: "Aktualizovat doklad",
			Categories: {
				personal: "Osobní doklady",
				vehicles: "Vozidla a doprava",
				sport: "Záliby a sport",
				insurance: "Pojištění",
				other: "Ostatní",
			},
			Form: {
				sectionTitle: "Údaje dokladu",
				type: "Typ dokladu",
				number: "Číslo dokladu",
				validTo: "Platnost do",
				noExpiry: "Bez data platnosti",
				selectDate: "Vybrat datum",
				customName: "Název dokladu",
				customNamePlaceholder: "Zbrojní průkaz, EHIC, ...",
				note: "Poznámka (nepovinné)",
				notePlaceholder: "nepovinné",
				submit: "Uložit doklad",
			},
			Success: {
				title: "Doklad uložen!",
				updateTitle: "Doklad aktualizován",
				description: "{{name}} byl úspěšně přidán do vašich dokladů.",
				updateDescription: "Údaje dokladu {{name}} byly úspěšně aktualizovány.",
				reminderSet: "Připomenutí bylo nastaveno.",
				expiryNote: "Systém vás upozorní před vypršením platnosti.",
				viewInWallet: "Zobrazit doklady",
				viewDocument: "Zobrazit doklad",
				addAnother: "Přidat další doklad",
				back: "Zpět",
			},
		},
	},
	Advisor: {
		title: "Můj poradce",
		call: "Zavolat",
		messages: "Zprávy",
		mainBadge: "Hlavní",
		pickerTitle: "Vaši poradci",
		introduction: "Představení",
		showFull: "Zobrazit celé",
		emailAria: "Napsat na {{email}}",
		addressAria: "Otevřít adresu {{address}} v mapě",
		linkedinAria: "Otevřít profil LinkedIn",
		websiteAria: "Otevřít webové stránky",
		makeMainAria: "Nastavit poradce {{name}} jako hlavního",
		pickerAria: "Vaši poradci, čekající žádosti: {{count}}",
		deleteAria: "Smazat {{name}}",
		pendingHeading: "Žádosti o propojení ({{count}})",
		connectedHeading: "Propojení poradci",
		approve: "Schválit",
		refuse: "Odmítnout",
		keep: "Ponechat",
		unreadMessages: "{{count}} nepřečtených zpráv",
		unreadMessages_one: "{{count}} nepřečtená zpráva",
		unreadMessages_few: "{{count}} nepřečtené zprávy",
		unreadMessages_other: "{{count}} nepřečtených zpráv",
		specializations: {
			investments: "investice",
			life_insurance: "životní pojištění",
			non_life_insurance: "neživotní pojištění",
			mortgages: "hypotéky",
			consumer_loans: "spotřebitelské úvěry",
			retirement: "penze",
			comprehensive: "komplexní poradenství",
		},
		assistantsHeading: "Asistentky",
		assistant: "Asistentka",
		worksWith: "Pracuje s poradcem: {{name}}",
		phoneAria: "Zavolat na číslo {{phone}}",
		assistantChatAria: "Napsat zprávu asistentce {{name}}",
		assistantChatUnreadAria:
			"Napsat zprávu asistentce {{name}}, máte nepřečtenou zprávu",
		assistantOpenAria: "Otevřít asistentku {{name}}",
		assistantEmptyTitle: "Není vybraná žádná asistentka",
		assistantEmptyDescription:
			"Asistentku otevřete šipkou u jejího jména na profilu poradce.",
		backToAdvisor: "Na profil poradce",
		mainConfirm: {
			title: "Zvolit hlavního poradce",
			description:
				"Opravdu chcete zvolit {{name}} jako svého hlavního poradce?",
			confirm: "Nastavit jako hlavního",
		},
		deleteConfirm: {
			advisorTitle: "Smazat poradce",
			assistantTitle: "Smazat asistentku",
			advisorDescription: "Opravdu chcete smazat poradce {{name}}?",
			advisorSharedDescription:
				"Opravdu chcete smazat poradce {{name}}? Přijdete tím o smlouvy, majetek a služby, které s vámi tento poradce sdílel.",
			assistantDescription: "Opravdu chcete smazat asistentku {{name}}?",
			assistantSharedDescription:
				"Opravdu chcete smazat asistentku {{name}}? Přijdete tím o smlouvy, majetek a služby, které s vámi tato asistentka sdílela.",
			advisorConfirm: "Smazat poradce",
			assistantConfirm: "Smazat asistentku",
		},
		refuseConfirm: {
			title: "Odmítnout žádost",
			description: "{{name}} se s vámi nepropojí a žádost zmizí ze seznamu.",
			confirm: "Odmítnout žádost",
		},
		loadError: {
			title: "Poradce se nepodařilo načíst",
			description: "Při načítání dat došlo k chybě. Zkuste to prosím znovu.",
			retry: "Zkusit znovu",
		},
	},
	Chat: {
		title: "Zprávy",
		inputPlaceholder: "Napsat zprávu...",
		online: "Online",
		today: "Dnes",
		yesterday: "Včera",
		loadOlder: "Načíst starší zprávy",
		emptyTitle: "Zatím žádné zprávy",
		emptyDescription: "Napište svému poradci první zprávu.",
		sendError: "Zprávu se nepodařilo odeslat.",
		retry: "Odeslat znovu",
		attachmentImage: "Fotka",
		attachmentFile: "Dokument",
		searchPlaceholder: "Hledat v konverzacích...",
		newMessage: "Nová zpráva",
		youPrefix: "Vy:",
		listEmptyTitle: "Zatím žádné zprávy",
		listEmptyDescription:
			"Napište svému poradci — odpoví vám obvykle do pár hodin.",
		searchEmptyTitle: "Nic jsme nenašli",
		searchEmptyDescription: "Zkuste upravit hledaný výraz nebo jméno poradce.",
		clearSearch: "Zrušit hledání",
		writeToAdvisor: "Napsat poradci",
	},
	Settings: {
		title: "Více",
		DarkMode: "Tmavý režim",
		Language: "Jazyk",
		LogOut: "Odhlásit se",
		RemoveAccount: "Odstranit účet",
		AppVersion: "Verze aplikace",
		LanguageOptions: {
			Czech: "Čeština",
			English: "English",
		},
		Sections: {
			Tools: "Nástroje",
			Settings: "Nastavení",
			Account: "Účet",
		},
		Items: {
			FinancialBalance: "Finanční bilance",
			MyDocuments: "Moje doklady",
			Activities: "Aktivity",
			Calculators: "Kalkulačky",
			Settings: "Nastavení",
			Security: "Zabezpečení",
		},
		Copyright: "© 2026 SAB servis s.r.o.",
	},
	Calculators: {
		title: "Kalkulačky",
		ListError: "Kalkulačky se nepodařilo načíst. Zkuste to, prosím, později.",
		ListEmpty: "Kalkulačky tu zatím nejsou k dispozici.",
		Sections: {
			loansAndHousing: "Úvěry a bydlení",
			savingsAndInvestments: "Spoření a investice",
			insurance: "Pojištění",
		},
		Names: {
			mortgage: "Hypoteční kalkulačka",
			refinancing: "Refinancování hypotéky",
			americanMortgage: "Americká hypotéka",
			consumerLoan: "Spotřebitelský úvěr",
			pensionAnnuity: "Důchodová renta",
			childrenSavings: "Spoření pro děti",
			goalAchieve: "Dosažení cíle",
			travelInsurance: "Cestovní pojištění",
			carMotoInsurance: "Pojištění vozidel",
			propertyInsurance: "Pojištění majetku",
		},
		Descriptions: {
			mortgage: "Spočítejte si splátku hypotéky",
			refinancing: "Kolik ušetříte na lepší sazbě",
			americanMortgage: "Půjčka na cokoli s ručením nemovitostí",
			consumerLoan: "Splátka úvěru na cokoli",
			pensionAnnuity: "Kolik spořit na rentu v důchodu",
			childrenSavings: "Naspořte dětem na budoucnost",
			goalAchieve: "Kolik spořit, abyste dosáhli cíle",
			travelInsurance: "Sjednejte si pojištění na cesty",
			carMotoInsurance: "Povinné ručení a havarijní",
			propertyInsurance: "Pojištění nemovitosti a domácnosti",
		},
		Intros: {
			mortgage:
				"Spočítejte si měsíční splátku hypotéky a porovnáme pro vás sazby našich partnerů.",
			refinancing:
				"Zjistěte, kolik můžete ušetřit, když přejdete na výhodnější sazbu.",
			americanMortgage: "Půjčka na cokoli s ručením nemovitostí.",
			consumerLoan: "Spočítejte si měsíční splátku úvěru na cokoli.",
			pensionAnnuity:
				"Spočítejte si, kolik měsíčně spořit pro vysněnou rentu v důchodu.",
			childrenSavings:
				"Myslete na svoje děti a spočítejte si, kolik měsíčně spořit na jejich budoucnost.",
			goalAchieve:
				"Spočítejte si, kolik měsíčně spořit, abyste dosáhli svého cíle.",
			travelInsurance: "Sjednejte si pojištění na cesty.",
			carMotoInsurance: "Sjednejte si povinné ručení nebo havarijní pojištění.",
			propertyInsurance: "Sjednejte si pojištění nemovitosti a domácnosti.",
		},
		Result: {
			Badges: {
				monthlyInstalment: "Měsíční splátka",
				monthlySaving: "Měsíčně ušetříte",
				todaySave: "Dnes stačí spořit",
				comparisonResult: "Výsledek porovnání",
			},
			Unit: "Kč měsíčně",
			RateValue: "{{rate}} %",
			RateValueFrom: "od {{rate}} %",
			RateMeta: "{{unit}} · {{rate}} % ročně",
			NewRateMeta: "{{unit}} · nová sazba {{rate}} %",
			LeadHint:
				"Pošlete nezávaznou poptávku, poradce vám připraví nabídku na míru.",
			ContactAdvisor: "Kontaktovat poradce",
			SentTitle: "Hotovo",
			SentText: "Požadavek jsme odeslali poradci.",
			WaitingNote:
				"Když počkáte {{years}}, bude to <b>{{later}} měsíčně</b>, o <b>{{extra}}</b> víc.",
			CompareTitle: "Porovnali jsme pro vás",
			CompareIntro:
				"Úrokové sazby našich bankovních partnerů. Konkrétní banky vám ukáže poradce v nabídce.",
			CompareIntroYourRate:
				"Vaši současnou sazbu jsme porovnali se sazbami našich {{count}} bankovních partnerů. Konkrétní banky vám ukáže poradce v nabídce.",
			CompareFooter:
				"Naši specialisté to často zvládnou ještě lépe, zeptejte se.",
			YourRate: "Vaše sazba",
			BetterCount: "Lepší u {{count}} bank",
			BetterCount_one: "Lepší u {{count}} banky",
			BetterCount_few: "Lepší u {{count}} bank",
			BetterCount_other: "Lepší u {{count}} bank",
			WorseCount: "Horší u {{count}} bank",
			WorseCount_one: "Horší u {{count}} banky",
			WorseCount_few: "Horší u {{count}} bank",
			WorseCount_other: "Horší u {{count}} bank",
			BankLabel: "Banka {{index}}",
			BankRangeLabel: "Banka {{from}}-{{to}}",
			NotOffered: "Tuto variantu nenabízí",
			NoOffer: "Tuto variantu žádná banka nenabízí",
			RatesUnavailable:
				"Sazby bank se teď nepodařilo načíst. Zkuste to, prosím, později.",
			LeadErrorTitle: "Zkuste to, prosím, později.",
			LeadErrorText: "Něco se pokazilo.",
			LeadErrorButton: "OK",
		},
		SelectPlaceholder: "Vybrat",
		FillPlaceholder: "Vyplnit",
		Validation: {
			MinAmount: "Minimální částka je {{amount}}.",
			MaxAmount: "Maximální částka je {{amount}}.",
			MaxRate: "Maximální sazba je {{rate}} %.",
			AmountPositive: "Částka musí být větší než 0.",
			RatePositive: "Sazba musí být větší než 0.",
		},
		Mortgage: {
			PropertyPrice: "Hodnota nemovitosti",
			Years: "Délka splácení",
			LoanValue: "Chcete si půjčit",
			ResultLoanValue: "Výše úvěru",
			ResultLtv: "LTV",
		},
		Refinancing: {
			PropertyPrice: "Původní hodnota nemovitosti",
			PropertyPriceMissing:
				"Doplňte hodnotu nemovitosti. Bez ní nejde spočítat, kolik ušetříte.",
			MonthlyPayment: "Původní měsíční splátka",
			Interest: "Původní úroková sazba",
			Years: "Původní doba splácení",
			PaidPeriod: "Jak dlouho už splácíte",
			ResultNewInstalment: "Nová měsíční splátka",
			ResultRemaining: "Zbývá splácet",
			ResultBetterThanPartners:
				"Teď máte lepší sazbu, než nabízejí naši partneři.",
			ResultSameAsPartners:
				"Teď máte stejnou sazbu, jakou nabízejí naši partneři.",
		},
		AmericanMortgage: {
			PropertyPrice: "Hodnota nemovitosti",
			LoanValue: "Chcete si půjčit",
			Years: "Délka splácení",
			ResultLoanValue: "Výše úvěru",
		},
		ConsumerLoan: {
			LoanValue: "Kolik chcete půjčit",
			Purpose: "Účel půjčky",
			Years: "Jak dlouho chcete splácet",
			Purposes: {
				anything: "Na cokoliv",
				reconstruction: "Rekonstrukce",
				household: "Na vybavení domácnosti",
				car: "Na auto",
			},
		},
		PensionAnnuity: {
			MonthlyAnnuity: "Požadovaná měsíční renta",
			InitialDeposit: "Počáteční vklad",
			Duration: "Délka čerpání renty",
			YearsUntil: "Za jak dlouho chcete peníze čerpat",
			ResultRequiredAmount: "Bude potřeba naspořit",
			ResultCoveredByDeposit: "Na tuto rentu vám stačí počáteční vklad.",
		},
		Savings: {
			TargetAmount: "Požadovaná částka",
			Years: "Za kolik let chcete peníze použít",
			ChildrenReason: "S čím chcete dětem pomoci",
			ChildrenReasons: {
				startToLife: "Start do života",
				study: "Studium",
				housing: "Bydlení",
				hobbies: "Zájmy",
			},
			GoalReason: "Jaký máte cíl",
			GoalReasons: {
				car: "Auto",
				travelAroundTheWorld: "Cesta kolem světa",
				financialReserve: "Finanční rezerva",
				other: "Jiné",
			},
		},
		Unavailable: {
			Tag: "Nedostupné",
			Title: "Tohle si tu zatím nesjednáte",
			Text: "{{product}} vám váš poradce přes aplikaci nesjedná. Napište mu, domluvíte se, jak dál.",
			Button: "Napsat poradci",
			ChatMessage:
				"Dobrý den, chtěl/a bych si sjednat {{product}}, ale v aplikaci to nejde. Můžete mi prosím poradit?",
		},
		Years: "{{count}} rok",
		Years_one: "{{count}} rok",
		Years_few: "{{count}} roky",
		Years_other: "{{count}} let",
	},
	Security: {
		title: "Zabezpečení",
		Biometry: "Biometrie",
		BiometryError: "Nepodařilo se změnit nastavení biometrie",
		BiometrySetupFailed:
			"Nastavení se nezdařilo. Zapněte biometrii v nastavení telefonu.",
		Sections: {
			Login: "Přihlášení",
		},
	},
	Dashboard: {
		TitleCard: {
			title: "Detail",
			tooltip:
				"Přehled vychází z údajů poskytnutých finanční institucí nebo poradcem. Pokud si chcete správnost dat ověřit, kontaktujte prosím svého poradce.",
			zeroValue:
				"Máte tu <b>{{count}}</b> položek bez hodnoty. Domluvte se s poradcem na doplnění údajů.",
			zeroValue_one:
				"Máte tu <b>{{count}}</b> položku bez hodnoty. Domluvte se s poradcem na doplnění údajů.",
			zeroValue_few:
				"Máte tu <b>{{count}}</b> položky bez hodnoty. Domluvte se s poradcem na doplnění údajů.",
			zeroValue_other:
				"Máte tu <b>{{count}}</b> položek bez hodnoty. Domluvte se s poradcem na doplnění údajů.",
			netValue: "čistá hodnota: {{value}}",
			netValueTooltip:
				"Hodnota po odečtení vašich závazků (úvěry, hypotéky, leasing). Pokud váš majetek není kompletní, kontaktujte svého poradce.",
		},
		GoalsCard: {
			title: "Cíle",
			percent: "{{percent}} %",
			moreGoalsCount: "+{{count}}",
			moreGoals: "dalších cílů",
			moreGoals_one: "další cíl",
			moreGoals_few: "další cíle",
			moreGoals_other: "dalších cílů",
		},
		Empty: {
			label: "Žádný obsah",
			description:
				"Klient nemá k dispozici žádná data reportingu. Reporting zapnete v detailu klienta přepínačem „Zobrazit reporting v myPLANN“.",
		},
		EmptyState: {
			eyebrow: "Tohle je váš myPLANN",
			title: "Vaše finance pohromadě",
			description:
				"Smlouvy, dokumenty, cíle – čím víc tu máte, tím jasněji vidíte.",
			addContractButton: "Přidat smlouvu",
			viewContractsButton: "Zobrazit smlouvy",
			uploadDocumentButton: "Nahrát dokument",
			viewDocumentsButton: "Zobrazit dokumenty",
			addGoalButton: "Přidat cíl",
		},
		Detail: {
			back: "Zpět",
			loadErrorTitle: "Přehled se nepodařilo načíst",
			loadErrorDescription: "Zkontrolujte připojení a zkuste to znovu.",
			retry: "Zkusit znovu",
			Add: {
				Total: "Přidat do portfolia",
				Cash: "Přidat účet ručně",
				Investment: "Přidat investiční smlouvu",
				InvestmentProperty: "Přidat investiční majetek",
				Liabilities: "Přidat závazek",
				Other: "Přidat majetek",
			},
		},
		OverviewType: {
			Total: "Celkový majetek",
			Cash: "Hotovost",
			Investment: "Investice",
			InvestmentProperty: "Investiční majetek",
			Liabilities: "Závazky",
			Other: "Ostatní majetek",
		},
		NotificationSections: {
			ResolvingNow: "Právě řešíme",
			Upcoming: "Blížící se",
			Recent: "Už proběhlo",
			ShowAll: "Zobrazit vše",
		},
		ImageCard: {
			title: "Mohlo by se hodit",
			Mortgage: {
				title: "Jednoduchá kalkulačka hypoték na pár ťuknutí",
				description: "Porovnejte si nabídky online nebo využite naše poradce",
			},
			Travel: {
				title: "Vyberte si vhodný výlet",
				description: "Vyberte si vhodný výlet a vyplňte formulář",
			},
		},
		Inspiration: {
			title: "Inspirace",
			seeAll: "Všechny inspirace",
			Cards: {
				ownHome: "Vlastní střecha nad hlavou",
				earlyFreedom: "Finanční nezávislost",
				retirement: "Důchod podle vašich představ",
			},
		},
		QuickCalculators: {
			title: "Mohlo by se hodit",
			allCalculators: "Všechny kalkulačky",
			Items: {
				travelInsurance: "Cestovní pojištění",
				propertyInsurance: "Pojištění majetku",
				carMotoInsurance: "Pojištění vozidel",
				consumerLoan: "Spotřebitelský úvěr",
				mortgage: "Hypotéka",
			},
		},
		FinancialBalance: {
			title: "Finanční bilance",
			subtitlePositive: "Měsíčně vám zůstává v průměru",
			subtitleNegative: "Měsíčně vám chybí v průměru",
			descriptionPositive:
				"Chcete přebytky svého rozpočtu dále zhodnotit? Spojte se se svým poradcem a začněte si tvořit klidnou budoucnost již dnes.",
			descriptionNegative:
				"Spojte se se svým poradcem a najděte společně způsob, jak bilanci zlepšit.",
			startButton: "Začít",
			clientNotFound:
				"Klient pod zvoleným poradcem není evidován, z toho důvodu nemůžete zobrazit finanční bilanci. Kontaktujte prosím svého poradce.",
			income: "Příjmy",
			expense: "Výdaje",
			balance: "Zůstatek",
			detail: "Detail",
			emptyTitle: "Kolik vám měsíčně zbývá?",
			emptyDescription:
				"5 minut a víte. Řekněte nám příjmy a výdaje, zbytek spočítáme.",
			emptyCta: "Chci to vědět",
			tipPositive: "Máte volných {{amount}} měsíčně. Co takhle je zhodnotit?",
			tipNegative:
				"Vaše výdaje převyšují příjmy. Proberte to se svým poradcem.",
			Modal1: {
				title: "Finanční bilance",
				description:
					"Pokud potřebujete probrat vhodné řešení, jak nejlépe pracovat s jejím výsledkem, klikněte na tlačítko “Mám zájem” a tato informace se odešle vašemu poradci.",
				button: "Mám zájem",
			},
			Modal2: {
				title: "Děkujeme za váš zájem",
				description:
					"Váš poradce se s vámi spojí a navrhne nejlepší možné řešení.",
			},
			contactAdvisorButton: "Kontaktovat poradce",
		},
		Sections: {
			todo: "Právě řešíme",
			upcoming: "Blížící se",
			past: "Už proběhlo",
		},
		RelativeDate: {
			today: "Dnes",
			future: "Za {{count}} dní",
			future_one: "Za {{count}} den",
			future_few: "Za {{count}} dny",
			future_other: "Za {{count}} dní",
			past: "Před {{count}} dní",
			past_one: "Před {{count}} den",
			past_few: "Před {{count}} dny",
			past_other: "Před {{count}} dní",
		},
		ShowAllButton: {
			title: "Zobrazit vše",
		},
		UserType: {
			[UserTypeEnum.Client]: "Klient",
			[UserTypeEnum.Agent]: "Poradce",
			[UserTypeEnum.Assistant]: "Asistentka",
		},
		EmptyList: {
			label: "Žádný obsah",
			description:
				"Přehled vašeho portfolia se zobrazí, jakmile ho váš poradce připraví a nasdílí.",
		},
	},
	Task: {
		Detail: {
			title: "Úkol",
			notFoundToast: "Úkol už neexistuje",
			BasicInfo: {
				title: "Základní údaje",
				Name: "Název",
				Date: "Datum",
				CreatedBy: "Vytvořil",
				Solver: "Řešitel",
				Desc: "Popis",
			},
			Process: {
				title: "Průběh",
			},
		},
	},
	Activity: {
		Detail: {
			title: "Aktivita",
			notFoundToast: "Aktivita už neexistuje",
			BasicInfo: {
				title: "Základní údaje",
				Name: "Název",
				Type: "Typ aktivity",
				State: "Stav",
				Date: "Datum",
				Address: "Adresa",
				CreatedBy: "Vytvořil",
			},
			Participants: {
				title: "Účastníci",
				client: "Klient",
			},
			Agents: {
				advisor: "Poradce",
				assistant: "Asistentka",
			},
			OtherClient: "Jiná osoba",
			notes: "Zápis a poznámky",
			ToolbarMenu: {
				WritteMessage: "Napsat zprávu",
				Call: "Volat",
				WritteSMS: "Napsat SMS",
				WritteEmail: "Napsat E-mail",
			},
		},
		List: {
			title: "Aktivity",
			NoTask: "Momentálně neřešíme žádné úkoly.",
			NoContent: "Žádný obsah",
			NoActivities:
				"Tady uvidíte všechny proběhlé nebo naplánované aktivity s vaším poradcem.",
			NoUpcomingEvents: "Žádné nadcházející události.",
			NoOverdueEvents: "Žádné uplynulé události.",
			NoResolvedEvents: "Žádné uzavřené aktivity.",
			EventType: {
				[ClientEventTypeEnum.Task]: "Úkol",
				[ClientEventTypeEnum.Activity]: "Aktivita",
			},
			ActivityType: {
				[ClientActivityTypeEnum.Call]: "Hovor",
				[ClientActivityTypeEnum.Meeting]: "Schůzka",
				[ClientActivityTypeEnum.Other]: "Jiná aktivita",
				[ClientActivityTypeEnum.Administration]: "Administrativa",
			},
			Task: "Úkol",
			From: "od",
			To: "do",
		},
	},
	Portfolio: {
		Chart: {
			Value: "Hodnota",
			Invested: "Investováno",
			InvestedTogether: "Investováno celkem",
			RemainsToPay: "Zbývá splatit",
			Paid: "Splaceno",
			Date: "Datum",
			To: "K datu",
			Tooltip:
				"Přehled vychází z dat od finančních institucí, nebo zadaných poradcem. Pro ověření a bližší informace se obraťte na svého poradce.",
			ReportingDataUnavailable:
				"Pro zobrazení grafu nejsou momentálně dostupná všechna potřebná data.",
		},
		Titles: {
			document: "Dokumenty",
			portfolio: "Portfolio",
		},
		List: {
			BookmarkTileTitle: "Chybí tady smlouva?",
			BookmarkTileDesc:
				"Přidejte si smlouvu, která tady chybí, abyste měli všechny na jednom místě.",
			Tabs: {
				portfolio: "Portfolio",
				documents: "Dokumenty",
			},
			Sorter: {
				title: "Uspořádat podle",
				Types: {
					default: "Oblasti",
					producer: "Poskytovatel",
					date: "Datum podpisu",
				},
			},
			AddDocumentDrawer: {
				title: "Přidat dokument",
				pickError: "Soubor se nepodařilo načíst. Zkuste to prosím znovu.",
				uploadError:
					"Dokument se nepodařilo nahrát. Zkontrolujte připojení a zkuste to prosím znovu.",
				Types: {
					photo: "Vyfotit nový dokument",
					gallery: "Nahrát dokument z galerie",
					file: "Nahrát dokument ze souborů",
				},
			},
			FolderActionsDrawer: {
				title: "Akce se složkou",
				Actions: {
					rename: "Přejmenovat",
				},
			},
			DocumentActionsDrawer: {
				title: "Akce s dokumentem",
				fileDrawerTitle: "Přesunout do složky",
				folderDrawerTitle: "Akce se složkou",
				Actions: {
					download: "Stáhnout",
					removeDownload: "Odstranit ze stažených položek",
					rename: "Přejmenovat",
					delete: "Smazat",
					share: "Sdílet",
					move: "Přesunout do složky",
				},
				Rename: {
					fileRename: "Název dokumentu",
					folderRename: "Název složky",
				},
			},
			MoveDocumentDialog: {
				title: "Přesunout dokument",
				Actions: {
					create: "Nová složka",
				},
			},
			DeleteDocumentDialog: {
				title: "Smazat dokument?",
				description: "Opravdu chcete smazat dokument {{documentName}}?",
				confirm: "Smazat",
				cancel: "Zrušit",
			},
			PortfolioDomainType: {
				[ClientPortfolioDomainEnum.BankingProducts]: "Bankovní produkty",
				[ClientPortfolioDomainEnum.BuildingSavings]: "Stavební spoření",
				[ClientPortfolioDomainEnum.BusinessLoans]: "Podnikatelský úvěr",
				[ClientPortfolioDomainEnum.Commodities]: "Komodity",
				[ClientPortfolioDomainEnum.Cryptocurrencies]: "Kryptoměny",
				[ClientPortfolioDomainEnum.Investments]: "Investice",
				[ClientPortfolioDomainEnum.Leasing]: "Leasing",
				[ClientPortfolioDomainEnum.LifeInsurance]: "Životní pojištění",
				[ClientPortfolioDomainEnum.Loans]: "Úvěry",
				[ClientPortfolioDomainEnum.PaidAdvisory]: "Placení poradenství",
				[ClientPortfolioDomainEnum.PensionProducts]: "Penzijní produkty",
				[ClientPortfolioDomainEnum.PropertyInsurance]: "Neživotní pojištění",
				[ClientPortfolioDomainEnum.Services]: "Služby",
				Uncategorized: "Bez kategorie",
			},
			PortfolioDomainAbbreviation: {
				[ClientPortfolioDomainEnum.LifeInsurance]: "ŽP",
				[ClientPortfolioDomainEnum.PropertyInsurance]: "NP",
				[ClientPortfolioDomainEnum.PensionProducts]: "PP",
				[ClientPortfolioDomainEnum.BuildingSavings]: "SS",
				[ClientPortfolioDomainEnum.Investments]: "I",
				[ClientPortfolioDomainEnum.BusinessLoans]: "UP",
				[ClientPortfolioDomainEnum.Loans]: "HU",
				[ClientPortfolioDomainEnum.Leasing]: "L",
				[ClientPortfolioDomainEnum.Commodities]: "K",
				[ClientPortfolioDomainEnum.Cryptocurrencies]: "C",
				[ClientPortfolioDomainEnum.BankingProducts]: "BP",
			},
			PortfolioSubType: {
				[ClientPropertyTypeEnum.AutoMoto]: "Auto/moto",
				[ClientPropertyTypeEnum.Flat]: "Byt",
				[ClientPropertyTypeEnum.House]: "Dům",
				[ClientPropertyTypeEnum.Cottage]: "Chata",
				[ClientPropertyTypeEnum.Land]: "Pozemek",
				[ClientPropertyTypeEnum.Art]: "Umění",
				[ClientPropertyTypeEnum.Commodity]: "Komodity",
				[ClientPortfolioDomainEnum.LifeInsurance]: "Životní pojištění",
				[ClientPortfolioDomainEnum.PropertyInsurance]: "Pojištění neživot",
				[ClientPortfolioDomainEnum.PensionProducts]: "Penzijní produkty",
				[ClientPortfolioDomainEnum.BuildingSavings]: "Stavební spoření",
				[ClientPortfolioDomainEnum.Investments]: "Investice",
				[ClientPortfolioDomainEnum.BusinessLoans]: "Podnikatelský úvěr",
				[ClientPortfolioDomainEnum.Loans]: "Úvěry",
				[ClientPortfolioDomainEnum.Leasing]: "Leasing",
				[ClientPortfolioDomainEnum.Commodities]: "Investiční komodity",
				[ClientPortfolioDomainEnum.BankingProducts]: "Bankovní produkty",
				[ClientPortfolioDomainEnum.Services]: "Služby",
				[ClientPortfolioDomainEnum.PaidAdvisory]: "Placená konzultace",
				[ClientPortfolioDomainEnum.Cryptocurrencies]: "Kryptoměny",
			},
			Property: "Majetek",
			Skeleton: {
				label: "Žádný obsah",
				description:
					"Tato stránka nemá žádná data, jakékoli dostupné portfolio se zobrazí právě tady.",
			},
			Redesign: {
				addItem: "Přidat smlouvu nebo majetek",
				selectedCategoriesCount: "{{count}} typů",
				selectedCategoriesCount_one: "{{count}} typ",
				selectedCategoriesCount_few: "{{count}} typy",
				selectedCategoriesCount_other: "{{count}} typů",
				investmentBadge: "Investiční",
				Categories: {
					financialProducts: "Finanční produkty",
					assets: "Majetek",
					services: "Služby",
				},
				PaymentFrequencyShort: {
					[ClientPortfolioPaymentFrequencyEnum.None]: "",
					[ClientPortfolioPaymentFrequencyEnum.Single]: "jednor.",
					[ClientPortfolioPaymentFrequencyEnum.Yearly]: "rok",
					[ClientPortfolioPaymentFrequencyEnum.Semiannually]: "pol.",
					[ClientPortfolioPaymentFrequencyEnum.Quarterly]: "čtvrtl.",
					[ClientPortfolioPaymentFrequencyEnum.Monthly]: "měs.",
				},
				Sort: {
					oblast: "Oblast",
					name: "Název",
					producer: "Poskytovatel",
					value: "Hodnota",
				},
				EmptyState: {
					headline: "Vše na jednom místě",
					description:
						"Přidejte smlouvy a majetek a mějte kompletní přehled o svých financích.",
					primaryCta: "Přidat první smlouvu",
					advisorTitle: "Poradce vám pomůže",
					advisorDescription: "Napište a společně naplníte portfolio.",
					PreviewCards: {
						insuranceLabel: "Pojistky",
						insuranceSub: "Životní, majetkové, cestovní",
						investmentLabel: "Investice",
						investmentSub: "Fondy, penzijko, spoření",
						realEstateLabel: "Nemovitosti",
						realEstateSub: "Hypotéky, bydlení, investiční",
						assetsLabel: "Majetek",
						assetsSub: "Vozidla, cennosti",
					},
				},
				Filter: {
					title: "Filtr",
					categoriesLabel: "Typ produktu",
					sortLabel: "Řazení",
					ascending: "Vzestupně",
					descending: "Sestupně",
					reset: "Resetovat",
					apply: "Použít filtry",
					activeSummaryLabel: "Aktivní filtry",
				},
				Documents: {
					addDocument: "Nahrát dokument",
					documentsCount: "{{count}} dokumentů",
					EmptyState: {
						headline: "Váš digitální šanon",
						description:
							"Bezpečné úložiště pro všechny smlouvy a dokumenty. Vždy po ruce, z jakéhokoli zařízení.",
						primaryCta: "Nahrát první dokument",
						trustBadge: "Šifrované úložiště v bankovním standardu",
						Steps: {
							photoLabel: "Vyfoťte smlouvu",
							photoDesc: "Stačí fotka z mobilu",
							aiLabel: "AI rozpozná data",
							aiDesc: "Automaticky vytáhne klíčové údaje",
							organizedLabel: "Vše přehledně",
							organizedDesc: "Dokumenty seřazené podle smluv",
						},
					},
				},
			},
		},
		AddItem: {
			title: "Co přidáváte?",
			Sections: {
				insurance: "Pojistky",
				savings: "Spoření a investice",
				loans: "Úvěry",
				property: "Majetek",
				other: "Ostatní",
			},
			Items: {
				lifeInsurance: "Životní pojištění",
				propertyInsurance: "Pojištění nemovitosti",
				householdInsurance: "Pojištění domácnosti",
				liabilityInsurance: "Pojištění odpovědnosti",
				vehicleInsurance: "Pojištění vozidel",
				travelInsurance: "Cestovní pojištění",
				businessInsurance: "Pojištění podnikatelů",
				accidentInsurance: "Úrazové pojištění",
				investment: "Investice",
				pension: "Penzijní produkt",
				buildingSavings: "Stavební spoření",
				bankProduct: "Bankovní produkt",
				crypto: "Krypto",
				commodity: "Komodity",
				mortgage: "Hypotéka",
				consumerLoan: "Spotřebitelský úvěr",
				businessLoan: "Podnikatelský úvěr",
				leasing: "Leasing",
				auto: "Auto/moto",
				propertyItem: "Nemovitost",
				art: "Umění",
				service: "Služba",
			},
		},
		EditProperty: {
			title: "Upravit majetek",
			submit: "Uložit změny",
			savedToast: "Položka {{type}} byla uložena",
		},
		EditPortfolio: {
			title: "Upravit smlouvu",
			serviceTitle: "Upravit službu",
			submit: "Uložit změny",
			savedToast: "Položka {{type}} byla uložena",
			UnsavedChanges: {
				title: "Neuložené změny",
				description: "Změny zatím nejsou uložené.",
				discard: "Zahodit",
			},
			Placeholders: {
				name: "Zadejte název",
				contractNumber: "Volitelné",
			},
		},
		Actions: {
			editContract: "Upravit smlouvu",
			editProperty: "Upravit majetek",
			editService: "Upravit službu",
			updateValue: "Aktualizovat hodnotu",
			deleteContract: "Smazat",
			DeleteProperty: {
				title: "Smazat majetek?",
				descriptionPrefix: "Opravdu chcete smazat ",
				descriptionSuffix: "? Tuto akci nelze vrátit zpět.",
				confirm: "Smazat",
				cancel: "Ponechat",
				successToast: "Majetek byl smazán",
			},
			DeletePortfolio: {
				title: "Smazat smlouvu?",
				descriptionPrefix: "Opravdu chcete smazat ",
				descriptionSuffix: "? Tuto akci nelze vrátit zpět.",
				confirm: "Smazat",
				cancel: "Ponechat",
				successToast: "Smlouva byla smazána",
			},
		},
		AddShared: {
			successTitle: "Hotovo",
			successHeadline: "Přidáno do portfolia!",
			successDescription: "Položka je okamžitě viditelná ve vašem portfoliu.",
			successHint: "Váš poradce dostal upozornění a může údaje dovyplnit.",
			successAddAnother: "Přidat další",
			successBackToPortfolio: "Zpět na portfolio",
			submit: "Přidat do portfolia",
			Placeholders: {
				fill: "Vyplnit",
				optional: "Nepovinné",
				searchOrEnterProducer: "Vyhledej poskytovatele nebo zadej vlastního",
				searchOrEnterProduct: "Vyhledej produkt nebo zadej vlastní",
				select: "Vybrat",
			},
			Combobox: {
				useValue: "Použít „{{value}}“",
				noSelection: "Nevybráno",
			},
			Validations: {
				required: "Povinné pole",
				maxLength: "Maximální délka je {{max}} znaků.",
				positiveNumber: "Hodnota musí být kladné číslo.",
				positiveInteger: "Hodnota musí být kladné celé číslo.",
				maxValue: "Hodnota je příliš vysoká.",
				startBeforeSigned: "Datum počátku nemůže být dříve než datum podpisu.",
				endBeforeSigned: "Datum ukončení nemůže být dříve než datum podpisu.",
				endBeforeStart: "Datum ukončení nemůže být dříve než datum počátku.",
				dateInFuture: "Datum nemůže být v budoucnosti.",
				valueRequiredWithInvested:
					"Investováno celkem jde uložit jen spolu s aktuální hodnotou.",
				fixationEndBeforeStart:
					"Konec fixace nemůže být dříve než datum počátku.",
				requiredMinimum:
					"Vyplňte aspoň jedno z polí {{fields}} nebo {{lastField}} — jinak nebude položku v portfoliu podle čeho poznat.",
				birthNumberFormat:
					"Zadejte rodné číslo ve tvaru 9601011234 nebo 960101/1234.",
			},
		},
		AddCar: {
			title: "Auto/moto",
			clientBannerTextBefore: "Položka bude označena jako ",
			clientBannerBadge: "Klientská",
			clientBannerTextAfter: ", poradce ji uvidí a doplní co chybí.",
			Sections: {
				identification: "Identifikace",
				valueAndDates: "Hodnota a data",
				engine: "Motor",
				description: "Doplňující popis",
			},
			Fields: {
				model: "Model",
				licensePlate: "RZ (registrační značka)",
				manufactureMonthYear: "Měsíc/rok výroby",
				description: "Doplňující popis",
			},
			Placeholders: {
				select: "Vybrat",
			},
			Validations: {
				positiveInteger: "Hodnota musí být kladné celé číslo.",
				vinFormat: "VIN musí mít přesně 17 alfanumerických znaků.",
				monthYearFormat: "Formát musí být MM/RRRR nebo RRRR.",
				notInFuture: "Datum nesmí být v budoucnosti.",
			},
		},
		AddArt: {
			title: "Umění",
			Sections: {
				basicInfo: "Základní údaje",
				description: "Doplňující popis",
				investment: "Zařazení",
			},
			Fields: {
				itemTitle: "Označení předmětu",
				shortDescription: "Název / popis",
				purchaseDate: "Datum pořízení",
				description: "Doplňující popis",
				value: "Aktuální hodnota",
				forInvestments: "Investiční majetek",
			},
			Validations: {
				notInFuture: "Datum nesmí být v budoucnosti.",
			},
		},
		EditLand: {
			submit: "Uložit změny",
			savedToast: "Položka {{type}} byla uložena",
		},
		AddRealEstate: {
			title: "Nemovitost",
			submit: "Přidat do portfolia",
			typeLabel: "Typ nemovitosti",
			typeDrawerTitle: "Vyberte typ",
			successTitle: "Hotovo",
			successHeadline: "Přidáno do portfolia!",
			successDescription: "Položka je okamžitě viditelná ve vašem portfoliu.",
			successHint: "Váš poradce dostal upozornění a může údaje dovyplnit.",
			successAddAnother: "Přidat další",
			successBackToPortfolio: "Zpět na portfolio",
			Types: {
				Land: "Pozemek",
				Flat: "Byt",
				House: "Rodinný dům",
				Cottage: "Jiná stavba",
			},
			Sections: {
				location: "Adresa",
				parameters: "Parametry",
				amenities: "Vybavení",
				valueAndDates: "Hodnota a data",
				description: "Doplňující popis",
			},
			Fields: {
				description: {
					Flat: "Doplňující popis bytu",
					House: "Doplňující popis domu",
					Cottage: "Doplňující popis stavby",
				},
			},
			Placeholders: {
				fill: "Vyplnit",
				optional: "Nepovinné",
			},
			Validations: {
				requiredMinimum:
					"Vyplňte ulici, obec, PSČ nebo popis — podle nich se nemovitost pozná v portfoliu.",
				maxLength: "Maximální délka je {{max}} znaků.",
				zipFormat: "PSČ musí mít 5 znaků.",
				positiveInteger: "Hodnota musí být kladné celé číslo.",
				maxValue: "Hodnota je příliš vysoká.",
			},
		},
		EditRealEstate: {
			submit: "Uložit změny",
			savedToast: "Položka {{type}} byla uložena",
		},
		AddLand: {
			title: "Pozemek",
			Sections: {
				basicInfo: "Základní údaje",
				location: "Adresa",
				valueAndDates: "Hodnota a data",
				description: "Doplňující popis",
			},
			Fields: {
				name: "Název",
				location: "Ulice a čp.",
				locationMunicipality: "Obec",
				locationZipCode: "PSČ",
				parcelNumber: "Parcelní číslo",
				landSize: "Plocha pozemku",
				value: "Aktuální cena",
				purchaseDate: "Datum pořízení",
				description: "Doplňující popis",
			},
			Validations: {
				zipFormat: "PSČ musí mít 5 znaků.",
				positiveInteger: "Hodnota musí být kladné celé číslo.",
				notInFuture: "Datum nesmí být v budoucnosti.",
			},
		},
		AddBuildingSavings: {
			title: "Stavební spoření",
			Sections: {
				basicInfo: "Základní údaje",
				values: "Hodnoty",
				additionalInfo: "Doplňující informace",
				note: "Poznámka",
			},
			Fields: {
				name: "Název smlouvy",
				contractNumber: "Číslo smlouvy",
				producer: "Poskytovatel",
				product: "Produkt",
				productCategory: "Kategorie produktu",
				signedAt: "Datum podpisu",
				startAt: "Datum počátku",
				endAt: "Datum ukončení",
				payment: "Pravidelný vklad",
				paymentFrequency: "Frekvence vkladu",
				appreciation: "Zhodnocení",
				targetAmount: "Cílová částka",
				stateContribution: "Státní příspěvek",
				note: "Poznámka",
			},
		},
		AddLifeInsurance: {
			title: "Životní pojištění",
			Sections: {
				basicInfo: "Základní informace",
				additionalInfo: "Doplňující informace",
			},
			Fields: {
				name: "Název smlouvy",
				contractNumber: "Číslo smlouvy",
				producer: "Poskytovatel",
				product: "Produkt",
				category: "Kategorie produktu",
				signedAt: "Datum podpisu",
				startAt: "Datum počátku",
				endAt: "Datum ukončení",
			},
		},
		AddNonLifeInsurance: {
			Titles: {
				property: "Pojištění nemovitosti",
				household: "Pojištění domácnosti",
				liability: "Pojištění odpovědnosti",
				vehicle: "Pojištění vozidel",
				travel: "Cestovní pojištění",
				business: "Pojištění podnikatelů",
				accident: "Úrazové pojištění",
			},
			NamePlaceholders: {
				property: "např. Pojištění bytu na Zbraslavi",
				household: "např. Domácnost byt Praha",
				liability: "např. čeho se pojistka týká",
				vehicle: "např. Povinné ručení Octavia",
				travel: "např. Cestovko celoroční",
				business: "např. Pojištění provozovny",
				accident: "např. Úrazovka děti",
			},
			AccidentNotice: {
				title: "Zakládáte samostatnou úrazovou smlouvu",
				description:
					"Pokud máte úraz sjednaný jako připojištění k životní smlouvě, patří do ní a zvlášť ho zakládat nemusíte.",
			},
			Sections: {
				basicInfo: "Základní údaje",
				insurance: "Pojistné",
				additionalInfo: "Doplňující informace",
			},
			Fields: {
				name: "Název smlouvy",
				contractNumber: "Číslo smlouvy",
				producer: "Poskytovatel",
				product: "Produkt",
				insurance: "Roční pojistné",
				insurancePeriod: "Lhůtní pojistné",
				paymentFrequency: "Frekvence platby",
				signedAt: "Datum podpisu",
				startAt: "Datum počátku",
				endAt: "Datum ukončení",
			},
		},
		AddCommodities: {
			title: "Komodity",
			Placeholders: {
				name: "např. Spoření ve zlatě",
			},
		},
		AddBankProduct: {
			title: "Bankovní produkt",
			Placeholders: {
				name: "např. Spořicí účet Fio",
			},
			Fields: {
				signedAt: "Datum založení",
			},
		},
		AddPension: {
			title: "Penzijní produkt",
			Sections: {
				basicInfo: "Základní údaje",
				values: "Hodnoty",
				additionalInfo: "Doplňující informace",
				note: "Poznámka",
			},
			Fields: {
				name: "Název smlouvy",
				contractNumber: "Číslo smlouvy",
				producer: "Poskytovatel",
				product: "Produkt",
				productCategory: "Kategorie produktu",
				signedAt: "Datum podpisu",
				startAt: "Datum počátku",
				endAt: "Datum ukončení",
				payment: "Vlastní příspěvek",
				paymentFrequency: "Frekvence vkladu",
				note: "Poznámka",
			},
		},
		AddTools: {
			Sections: {
				investmentTools: "Investiční nástroje",
				instructions: "Pokyny",
			},
			Fields: {
				toolType: "Typ nástroje",
				identificationType: "Typ identifikace",
				identification: "Identifikace",
				commodity: "Komodita",
				cryptocurrency: "Kryptoměna",
				holdingType: "Typ držení",
				name: "Název",
				accountName: "Název účtu",
				invested: "Investováno celkem",
				value: "Aktuální hodnota",
				valueDate: "K datu",
				instructionType: "Typ",
				startAt: "Datum počátku",
				endAt: "Datum ukončení",
				amount: "Částka",
				currency: "Měna",
				frequency: "Frekvence",
				count: "Množství",
				interestRate: "Zhodnocení",
			},
			Actions: {
				addTool: "Přidat investiční nástroj",
				addInstruction: "Přidat pokyn",
				createTool: "Přidat nástroj",
				saveChanges: "Uložit změny",
				cancel: "Zrušit",
				removeTool: "Odebrat nástroj",
				removeInstruction: "Odebrat pokyn",
			},
			Drawers: {
				tool: "Investiční nástroj",
				instruction: "Pokyn",
			},
			IdentificationType: {
				Isin: "ISIN",
				Other: "Ostatní",
			},
			Identification: {
				zlato: "Zlato",
				stribro: "Stříbro",
				platina: "Platina",
				palladium: "Palladium",
			},
			DuplicateIsin: {
				title: "Stejný ISIN už tu je",
				description:
					"Nástroj {{isin}} už na smlouvě máte. Po sloučení budou pokyny obou pod jedním nástrojem.",
				descriptionWithName:
					"Nástroj {{isin}} už na smlouvě máte jako {{name}}. Po sloučení budou pokyny obou pod jedním nástrojem.",
				confirm: "Sloučit",
				cancel: "Zrušit",
			},
			isinWarning:
				"ISIN má 12 znaků: 2 písmena, 9 písmen nebo číslic a kontrolní číslici. Uložit ho můžete i tak.",
			instructionsRequireTool:
				"Před přidáním pokynu vyplňte název nebo identifikaci nástroje.",
			commoditySearch: "Vyber komoditu nebo napiš vlastní",
			bondInstructionsHint: "Pokyny k tomuto dluhopisu spravuje váš poradce.",
			clientBondInstructionsHint: "Pokyny k dluhopisům zatím nelze zadat.",
			instructionSummary: "Pokyny: {{count}}",
			previousValues: "Dřívější hodnoty",
			deleteValue: "Smazat hodnotu {{value}} k {{date}}",
			updateValue: "Aktualizovat hodnotu",
			done: "Hotovo",
		},
		AddInvestment: {
			title: "Investice",
			Placeholders: {
				name: "např. Konzervativní fond Conseq",
			},
			Sections: {
				basicInfo: "Základní údaje",
				values: "Hodnoty",
				showValues: "Zobrazit hodnoty",
				hideValues: "Skrýt hodnoty",
				additionalInfo: "Doplňující informace",
				note: "Poznámka",
			},
			Fields: {
				name: "Název smlouvy",
				contractNumber: "Číslo smlouvy",
				producer: "Poskytovatel",
				product: "Produkt",
				value: "Aktuální hodnota",
				invested: "Investováno celkem",
				valueDate: "K datu",
				signedAt: "Datum podpisu",
				startAt: "Datum počátku",
				endAt: "Datum ukončení",
				note: "Poznámka",
			},
		},
		AddLeasing: {
			title: "Leasing",
			Sections: {
				basicInfo: "Základní údaje",
				values: "Parametry úvěru",
				additionalInfo: "Doplňující informace",
				coDebtors: "Spoludlužníci",
			},
			Fields: {
				name: "Název smlouvy",
				contractNumber: "Číslo smlouvy",
				producer: "Poskytovatel",
				product: "Produkt",
				signedAt: "Datum podpisu",
				startAt: "Datum počátku",
				endAt: "Datum ukončení",
				remainsToPay: "Zbývá splatit",
				originalObligationAmount: "Výše úvěru",
				installment: "Splátka",
				interestRate: "Úroková sazba",
				paymentFrequency: "Frekvence splátky",
			},
			namePlaceholder: "např. Leasing Kodiaq",
			showParameters: "Zobrazit parametry",
			hideParameters: "Skrýt parametry",
		},
		AddBusinessLoans: {
			title: "Podnikatelský úvěr",
			Sections: {
				basicInfo: "Základní údaje",
				values: "Parametry úvěru",
				additionalInfo: "Doplňující informace",
				coDebtors: "Spoludlužníci",
			},
			Fields: {
				name: "Název smlouvy",
				contractNumber: "Číslo smlouvy",
				producer: "Poskytovatel",
				product: "Produkt",
				signedAt: "Datum podpisu",
				startAt: "Datum počátku",
				endAt: "Datum ukončení",
				remainsToPay: "Zbývá splatit",
				originalObligationAmount: "Výše úvěru",
				installment: "Splátka",
				interestRate: "Úroková sazba",
				fixationEndDate: "Fixace do",
				paymentFrequency: "Frekvence splátky",
			},
			namePlaceholder: "např. Provozní úvěr firmy",
			showParameters: "Zobrazit parametry",
			hideParameters: "Skrýt parametry",
		},
		AddLoans: {
			Title: {
				mortgage: "Hypotéka",
				consumerLoan: "Spotřebitelský úvěr",
			},
			Sections: {
				basicInfo: "Základní údaje",
				values: "Parametry úvěru",
				additionalInfo: "Doplňující informace",
				coDebtors: "Spoludlužníci",
			},
			Fields: {
				name: "Název smlouvy",
				contractNumber: "Číslo smlouvy",
				producer: "Poskytovatel",
				product: "Produkt",
				signedAt: "Datum podpisu",
				startAt: "Datum počátku",
				endAt: "Datum ukončení",
				remainsToPay: "Zbývá splatit",
				originalObligationAmount: "Výše úvěru",
				installment: "Splátka",
				interestRate: "Úroková sazba",
				fixationEndDate: "Fixace do",
				paymentFrequency: "Frekvence splátky",
			},
			NamePlaceholder: {
				mortgage: "např. Hypotéka na byt v Praze",
				consumerLoan: "např. Půjčka na auto",
			},
			showParameters: "Zobrazit parametry",
			hideParameters: "Skrýt parametry",
		},
		CoDebtors: {
			drawerTitle: "Spoludlužník",
			save: "Uložit spoludlužníka",
			add: "Přidat spoludlužníka",
			remove: "Odebrat spoludlužníka",
			firstname: "Jméno",
			lastname: "Příjmení",
			identification: "Rodné číslo",
			duplicateIdentification:
				"Spoludlužník s tímto rodným číslem už je přidaný",
		},
		AddCryptocurrency: {
			title: "Kryptoměny",
			Placeholders: {
				name: "např. Účet u směnárny",
			},
		},
		AddServices: {
			title: "Služba",
			successTitle: "Hotovo",
			successHeadline: "Přidáno do portfolia!",
			successDescription: "Položka je okamžitě viditelná ve vašem portfoliu.",
			successHint: "Váš poradce dostal upozornění a může údaje dovyplnit.",
			successAddAnother: "Přidat další",
			successBackToPortfolio: "Zpět na portfolio",
			submit: "Přidat do portfolia",
			Sections: {
				basicInfo: "Základní údaje",
				values: "Parametry smlouvy",
				additionalInfo: "Doplňující informace",
				note: "Poznámka",
				showParameters: "Zobrazit parametry",
				hideParameters: "Skrýt parametry",
			},
			Fields: {
				name: "Název smlouvy",
				producer: "Poskytovatel",
				product: "Produkt",
				contractNumber: "Číslo smlouvy",
				tariff: "Tarif",
				commodityService: "Typ služby",
				unitOfMeasurement: "Měrná jednotka",
				pricePerUnit: "Cena za jednotku",
				pricePerUnitWithUnit: "Cena za {{unit}}",
				fixedPriceByFrequency: "Fixní cena",
				paymentFrequency: "Frekvence platby",
				depositAmount: "Výše zálohy",
				signedAt: "Datum podpisu",
				startAt: "Datum počátku",
				endAt: "Datum ukončení",
				note: "Poznámka",
			},
			Placeholders: {
				unitOfMeasurement: "např. kWh",
				contractName: "např. Elektřina byt Praha",
			},
			Validations: {
				maxLength: "Maximální délka je {{max}} znaků.",
				positiveNumber: "Hodnota musí být kladné číslo.",
				maxValue: "Hodnota je příliš vysoká.",
			},
		},
		Detail: {
			notAvailable: "Portfolio již není k dispozici",
		},
	},
	PortfolioDetail: {
		Pin: {
			alreadyPinned: "Už připnuté",
			unpin: "Odepnout",
			selectEmpty: "Zatím nemáte nic dalšího, co byste sem mohli připnout.",
			selectEmptyHint: "Novou položku přidáte pluskem v hlavičce portfolia.",
			selectEmptyAddItem: "Přidat položku do portfolia",
			Kind: {
				document: {
					chooseTitle: "Dokumenty",
					chooseIntro:
						"Připojte dokument, který už máte v Dokumentech, nebo nahrajte nový. Odepnutím se dokument odpojí od této položky, ale zůstane vám v Dokumentech.",
					existingTitle: "Existující dokument",
					existingSubtitle: "Vybrat z Dokumentů",
					newTitle: "Nový dokument",
					newSubtitle: "Nahrát a propojit",
					selectTitle: "Vyberte dokument",
				},
				contract: {
					chooseTitle: "Připnout smlouvu",
					chooseIntro:
						"Propojte tuto položku s další smlouvou ve vašem portfoliu.",
					existingTitle: "Existující smlouvu",
					existingSubtitle: "Vybrat z portfolia",
					selectTitle: "Vyberte smlouvu",
				},
				property: {
					chooseTitle: "Připnout majetek",
					chooseIntro: "Propojte tuto položku s majetkem ve vašem portfoliu.",
					existingTitle: "Existující majetek",
					existingSubtitle: "Vybrat z portfolia",
					selectTitle: "Vyberte majetek",
				},
				service: {
					chooseTitle: "Připnout službu",
					chooseIntro: "Propojte tuto položku se službou ve vašem portfoliu.",
					existingTitle: "Existující službu",
					existingSubtitle: "Vybrat z portfolia",
					selectTitle: "Vyberte službu",
				},
			},
		},
		InvestmentValue: {
			updateTitle: "Aktualizovat hodnotu",
			newValue: "Nová hodnota",
			invested: "Investováno celkem",
			date: "K datu",
			previousValue: "Předchozí hodnota:",
			placeholder: "Zadejte částku",
			confirm: "Uložit",
			backToFund: "Zpět na detail fondu",
			savedToast: "Hodnota aktualizována",
			positiveValue: "Zadejte hodnotu větší než nula.",
		},
		ChartTimeFrames: {
			threeMonths: "3M",
			sixMonths: "6M",
			oneYear: "1R",
			threeYears: "3R",
			fiveYears: "5R",
			all: "Vše",
		},
		SharedLabels: {
			name: "Jméno",
			contractNumber: "Číslo smlouvy",
			producent: "Poskytovatel",
			product: "Produkt",
			signDate: "Datum podpisu",
			beginDate: "Datum počátku",
			endDate: "Datum ukončení",
			untilAge: "do {{count}} let",
			Frequency: {
				[ClientPortfolioPaymentFrequencyEnum.Monthly]: "Měsíčně",
				[ClientPortfolioPaymentFrequencyEnum.Single]: "Jednorázově",
				[ClientPortfolioPaymentFrequencyEnum.Yearly]: "Ročně",
				[ClientPortfolioPaymentFrequencyEnum.Semiannually]: "Pololetně",
				[ClientPortfolioPaymentFrequencyEnum.Quarterly]: "Čtvrtletně",
				[ClientPortfolioPaymentFrequencyEnum.None]: "Žádný",
			},
			investedAll: "Investováno celkem",
			recurringPayment: "Pravidelná platba",
			currentValue: "Aktuální hodnota",
			targetAmount: "Cílová částka",
			paidAll: "Celková platba",
			empty: "Žádný obsah",
			emptySubtitle:
				"Tato stránka nemá žádná data, jakmile se něco změní, zobrazí se to právě tady.",
			Currency: {
				[CurrencyEnum.CZK]: "Kč",
				[CurrencyEnum.EUR]: "€",
				[CurrencyEnum.USD]: "$",
				[CurrencyEnum.GBP]: "£",
				[CurrencyEnum.JPY]: "¥",
				[CurrencyEnum.AUD]: "A$",
				[CurrencyEnum.SGD]: "S$",
				[CurrencyEnum.CHF]: "CHF",
				[CurrencyEnum.HUF]: "Ft",
				[CurrencyEnum.PLN]: "zł",
				[CurrencyEnum.NOK]: "kr",
				[CurrencyEnum.RON]: "lei",
				[CurrencyEnum.HKD]: "HK$",
				[CurrencyEnum.DKK]: "kr",
				[CurrencyEnum.CAD]: "C$",
				[CurrencyEnum.CNY]: "¥",
				[CurrencyEnum.NZD]: "NZ$",
				[CurrencyEnum.SEK]: "kr",
				[CurrencyEnum.TRY]: "₺",
				[CurrencyEnum.UNKNOWN]: "",
				Empty: "Bez měny",
			},
			CurrencyReverse: {
				[CurrencyEnum.CZK]: "CZK",
				[CurrencyEnum.EUR]: "EUR",
				[CurrencyEnum.USD]: "USD",
				[CurrencyEnum.GBP]: "GBP",
				[CurrencyEnum.JPY]: "JPY",
				[CurrencyEnum.AUD]: "AUD",
				[CurrencyEnum.SGD]: "SGD",
				[CurrencyEnum.CHF]: "CHF",
				[CurrencyEnum.HUF]: "HUF",
				[CurrencyEnum.PLN]: "PLN",
				[CurrencyEnum.NOK]: "NOK",
				[CurrencyEnum.RON]: "RON",
				[CurrencyEnum.HKD]: "HKD",
				[CurrencyEnum.DKK]: "DKK",
				[CurrencyEnum.CAD]: "CAD",
				[CurrencyEnum.CNY]: "CNY",
				[CurrencyEnum.NZD]: "NZD",
				[CurrencyEnum.SEK]: "SEK",
				[CurrencyEnum.TRY]: "TRY",
				[CurrencyEnum.UNKNOWN]: "",
				Empty: "Bez měny",
			},
		},
		LifeInsurance: {
			insuredAmount: "Pojistné",
			employersBonus: "Příspěvek zaměstnavatele",
			signDate: "Datum podpisu",
			beginDate: "Datum počátku",
			endDate: "Datum ukončení",
			EnsuredPeople: {
				title: "Pojištěné osoby",
				Variant: {
					Constant: "Konstantní",
					Decreasing: "Klesající",
					Annuities: "Anuitní",
					Retroactively: "Zpětně",
					NonRetroactively: "Nezpětně",
					Progression: "S progresí",
					Empty: "Prázdná",
				},
			},
			Risk: {
				[ClientPortfolioInsuredPersonRiskEnum.Death]: "Smrt",
				[ClientPortfolioInsuredPersonRiskEnum.DeathByAccident]: "Smrt úrazem",
				[ClientPortfolioInsuredPersonRiskEnum.Invalidity1]: "Invalidita 1",
				[ClientPortfolioInsuredPersonRiskEnum.Invalidity2]: "Invalidita 2",
				[ClientPortfolioInsuredPersonRiskEnum.Invalidity3]: "Invalidita 3",
				[ClientPortfolioInsuredPersonRiskEnum.Invalidity4]: "Invalidita 4",
				[ClientPortfolioInsuredPersonRiskEnum.SeriousIllness]:
					"Závažné onemocnění",
				[ClientPortfolioInsuredPersonRiskEnum.CancerFighting]:
					"Pro boj s rakovinou",
				[ClientPortfolioInsuredPersonRiskEnum.ForWoman]: "Pro ženy",
				[ClientPortfolioInsuredPersonRiskEnum.DailyCompensationForInjury]:
					"Denní odškodné za úraz",
				[ClientPortfolioInsuredPersonRiskEnum.BodilyDamageInjury]:
					"Tělesná poškození úrazem",
				[ClientPortfolioInsuredPersonRiskEnum.IncapacityForWork]:
					"Pracovní neschopnost",
				[ClientPortfolioInsuredPersonRiskEnum.Hospitalization]: "Hospitalizace",
				[ClientPortfolioInsuredPersonRiskEnum.PermanentConsequencesOfInjuryFrom05Percent]:
					"Trvalé následky úrazu od 0,5 %",
				[ClientPortfolioInsuredPersonRiskEnum.PermanentConsequencesOfInjuryFrom10Percent]:
					"Trvalé následky úrazu od 10 %",
				[ClientPortfolioInsuredPersonRiskEnum.LoanPackage]: "Úvěrový balíček",
			},
			InvestmentTool: {
				title: "Investiční nástroje",
				IdentificationType: {
					[ClientPortfolioToolIdentificationTypeEnum.Isin]: "ISIN",
					[ClientPortfolioToolIdentificationTypeEnum.Other]: "Identifikace",
					[ClientPortfolioToolIdentificationTypeEnum.Crypto]: "Kryptoměna",
					[ClientPortfolioToolIdentificationTypeEnum.BankProduct]:
						"Bankovní produkt",
					[ClientPortfolioToolIdentificationTypeEnum.Null]: "Null",
					[ClientPortfolioToolIdentificationTypeEnum.None]: "Žádná",
				},
				type: "Typ nástroje",
				Type: {
					[ClientPortfolioToolTypeEnum.Fund]: "Fondy",
					[ClientPortfolioToolTypeEnum.Bond]: "Dluhopisy",
					[ClientPortfolioToolTypeEnum.Other]: "Jiné",
					[ClientPortfolioToolTypeEnum.Commodity]: "Komodity",
					[ClientPortfolioToolTypeEnum.Crypto]: "Kryptoměny",
					[ClientPortfolioToolTypeEnum.BankProduct]: "Bankovní produkty",
					[ClientPortfolioToolTypeEnum.Share]: "Akcie",
				},
			},
		},
		NonLifeInsurance: {
			name: "Jméno",
			contractNumber: "Číslo smlouvy",
			producent: "Poskytovatel",
			product: "Produkt",
			insured: "Pojistné",
			insurancePeriod: "Lhůtní pojistné",
			AdditionalInfo: {
				signDate: "Datum podpisu",
				beginDate: "Datum počátku",
				endDate: "Datum ukončení",
			},
		},
		PensionProduct: {
			participantContribution: "Vlastní příspěvek",
			employerContribution: "Příspěvek zaměstnavatele",
			toAge: "Do věku klienta",
		},
		BuildingSavings: {
			savings: "Pravidelný vklad",
			appreciation: "Zhodnocení",
			stateContribution: "Pobírá státní příspěvek",
			note: "Poznámka",
		},
		LoanForBusiness: {
			endOfFixation: "Fixace do",
		},
		Loan: {
			coDebtors: "Spoludlužníci",
			amount: "Výše úvěru",
			matury: "Splatnost",
			interestRate: "Úroková sazba",
			installment: "Splátka",
			Frequency: {
				Years: "{{count}} rok",
				Years_one: "{{count}} rok",
				Years_few: "{{count}} roky",
				Years_other: "{{count}} let",
				Months: "{{count}} měsíc",
				Months_one: "{{count}} měsíc",
				Months_few: "{{count}} měsíce",
				Months_other: "{{count}} měsíců",
			},
		},
		Services: {
			name: "Jméno",
			contractNumber: "Číslo smlouvy",
			producent: "Poskytovatel",
			product: "Produkt",
			insured: "Pojistné",
			cardLabel: "Parametry smlouvy",
			advancePayment: "Výše zálohy",
			tariff: "Tarif",
			commodity: "Typ služby",
			pricePerUnit: "Cena za {{unit}}",
			pricePerUnitWithoutUnit: "Cena za jednotku",
			fixedPrice: "Fixní cena",
			CommodityService: {
				[ClientPortfolioDataCommodityServiceEnum.Electricity]: "Elektřina",
				[ClientPortfolioDataCommodityServiceEnum.Gas]: "Zemní plyn",
				[ClientPortfolioDataCommodityServiceEnum.Water]: "Voda",
				[ClientPortfolioDataCommodityServiceEnum.Internet]: "Internet",
				[ClientPortfolioDataCommodityServiceEnum.Television]: "Televize",
				[ClientPortfolioDataCommodityServiceEnum.CellPhoneTarrif]:
					"Mobilní tarif",
				[ClientPortfolioDataCommodityServiceEnum.Other]: "Jiná",
				[ClientPortfolioDataCommodityServiceEnum.None]: "Žádná",
			},
			AdditionalInfo: {
				signDate: "Datum podpisu",
				beginDate: "Datum počátku",
				endDate: "Datum ukončení",
				depositAmount: "Výše zálohy",
			},
		},
		PaidAdvisory: {
			fixedPrice: "Fixní cena",
		},
		ToolHistory: {
			title: "Historie pokynů",
			active: "Aktivní",
			nonActive: "Neaktivní",
			button: "Historie pokynů",
			purchase: "Nákup",
			ActionType: {
				[ClientPortfolioInvestmentTypeEnum.Buy]: "Nákup",
				[ClientPortfolioInvestmentTypeEnum.Sell]: "Prodej",
				[ClientPortfolioInvestmentTypeEnum.Empty]: "",
			},
			ActionTypeBankProduct: {
				[ClientPortfolioInvestmentTypeEnum.Buy]: "Vklad",
				[ClientPortfolioInvestmentTypeEnum.Sell]: "Výběr",
				[ClientPortfolioInvestmentTypeEnum.Empty]: "",
			},
			Fund: {
				type: "Typ pokynu",
				startDate: "Počátek pokynu",
				endDate: "Konec pokynu",
				amount: "Částka",
				frequency: "Frekvence",
				spread: "Spread",
				transactionType: "Typ transakce",
				disposition: "Další dispozice",
				entryTransaction: "Vstupní poplatek",
				entryTransactionAmount: "Výše poplatku",
				entryTransactionProcantage: "Strženo z prvních plateb",
				noFee: "Bez poplatku",
				applying: "Aplikace",
				Applying: {
					[ClientPortfolioInvestmentEnterFeeApplyingEnum.ChargedFeeFromInvestment]:
						"Strženo z investice",
					[ClientPortfolioInvestmentEnterFeeApplyingEnum.PaidExtra]:
						"Zaplaceno navíc",
				},
				Frequency: {
					[ClientPortfolioInvestmentFrequencyEnum.Monthly]: "Měsíčně",
					[ClientPortfolioInvestmentFrequencyEnum.EveryTwoMonths]:
						"Každé 2 měsíce",
					[ClientPortfolioInvestmentFrequencyEnum.Quarter]: "Čtvrtletně",
					[ClientPortfolioInvestmentFrequencyEnum.SemiYearly]: "Pololetně",
					[ClientPortfolioInvestmentFrequencyEnum.Yearly]: "Ročně",
					[ClientPortfolioInvestmentFrequencyEnum.Once]: "Jednorázově",
					[ClientPortfolioInvestmentFrequencyEnum.None]: "Žádná",
				},
				TransactionType: {
					[ClientPortfolioInvestmentTransactionEnum.Trade]: "Obchod",
					[ClientPortfolioInvestmentTransactionEnum.FundTransfer]:
						"Přestup mezi fondy",
				},
				EntryTransaction: {
					[ClientPortfolioInvestmentEnterFeeTypeEnum.Once]: "Jednorázový",
					[ClientPortfolioInvestmentEnterFeeTypeEnum.FromFirstPayments]:
						"Z prvních plateb",
					[ClientPortfolioInvestmentEnterFeeTypeEnum.FromEveryPayment]:
						"Z každé platby",
				},
				EntryTransactionAmount: {
					[ClientPortfolioInvestmentEnterFeeAmountTypeEnum.Amount]: "Kč",
					[ClientPortfolioInvestmentEnterFeeAmountTypeEnum.Percent]: "%",
				},
			},
			Bond: {
				issueDate: "Datum emise/koupě",
				maturityDate: "Datum splatnosti",
				value: "Cena",
				amount: "Počet kusů",
				interestRate: "Úročení/kupon",
				frequency: "Frekvence výplaty",
				yield: "Výnos p.a.",
				tax: "Zdanění",
				fee: "Poplatek podle frekvence",
				InterestType: {
					[ClientBondInterestTypeEnum.Fixed]: "Pevný úrok",
					[ClientBondInterestTypeEnum.Variable]: "Variabilní úrok",
					[ClientBondInterestTypeEnum.Nullable]: "Nulový kupon",
				},
			},
			Cryptocurrency: {
				title: "Detail kryptoměn",
				name: "Kryptoměna",
				holdingType: "Typ držení",
				amount: "Množství",
				HoldingType: {
					[ClientPortfolioInstructionHoldingTypeEnum.InAdministration]:
						"Ve správě",
					[ClientPortfolioInstructionHoldingTypeEnum.OwnWallet]:
						"Ve vlastní peněžence",
				},
				HoldingTypeShort: {
					[ClientPortfolioInstructionHoldingTypeEnum.InAdministration]: "S",
					[ClientPortfolioInstructionHoldingTypeEnum.OwnWallet]: "P",
				},
			},
			Commodity: {
				title: "Detail komodit",
				name: "Komodita",
			},
			BankProducts: {
				title: "Detail účtu",
				name: "Název účtu",
				currentValue: "Aktuální hodnota",
				evaluation: "Zhodnocení",
			},
		},
		Investment: {
			InvestmentTool: {
				title: "Detail investice",
			},
		},
		Property: {
			TypeOfConstruction: "Typ stavby",
			PropertyCategoryValue: {
				[ClientPropertyCategoryEnum.Apartment]: "Byt",
				[ClientPropertyCategoryEnum.OnKey]: "Na klíč",
				[ClientPropertyCategoryEnum.LowEnergy]: "Nízká energetická náročnost",
				[ClientPropertyCategoryEnum.Family]: "Rodinný dům",
				[ClientPropertyCategoryEnum.Villa]: "Vila",
				[ClientPropertyCategoryEnum.Garage]: "Garáž",
				[ClientPropertyCategoryEnum.HistoricalObject]: "Historický objekt",
				[ClientPropertyCategoryEnum.Cottage]: "Chalupa",
				[ClientPropertyCategoryEnum.CivicAmenityBuilding]:
					"Objekt obč. vybavenosti",
				[ClientPropertyCategoryEnum.Pond]: "Rybník",
				[ClientPropertyCategoryEnum.Farmstead]: "Zemědělská usedlost",
				[ClientPropertyCategoryEnum.OtherBuliding]: "Jiná",
				[ClientPropertyCategoryEnum.Livving]: "Bydlení",
				[ClientPropertyCategoryEnum.CommercialBuilding]: "Komerční budova",
				[ClientPropertyCategoryEnum.Garden]: "Zahrada",
				[ClientPropertyCategoryEnum.PermanentGrassGrowth]: "Trvalý trávník",
				[ClientPropertyCategoryEnum.Forest]: "Les",
				[ClientPropertyCategoryEnum.AgriculturalLand]: "Zemědělská půda",
				[ClientPropertyCategoryEnum.OtherLand_]: "Ostatní pozemek",
				[ClientPropertyCategoryEnum.None]: "Žádný",
			},
			PropertyType: {
				[ClientPropertyTypeEnum.Art]: "Umění",
				[ClientPropertyTypeEnum.AutoMoto]: "Auto/moto",
				[ClientPropertyTypeEnum.Commodity]: "Komodita",
				[ClientPropertyTypeEnum.Cottage]: "Jiná stavba",
				[ClientPropertyTypeEnum.Flat]: "Byt",
				[ClientPropertyTypeEnum.House]: "Rodinný dům",
				[ClientPropertyTypeEnum.Land]: "Pozemek",
			},
			PropertyGroup: {
				[ClientPropertyTypeEnum.Art]: "Umění",
				[ClientPropertyTypeEnum.AutoMoto]: "Auto/moto",
				[ClientPropertyTypeEnum.Commodity]: "Komodita",
				[ClientPropertyTypeEnum.Cottage]: "Nemovitost",
				[ClientPropertyTypeEnum.Flat]: "Nemovitost",
				[ClientPropertyTypeEnum.House]: "Nemovitost",
				[ClientPropertyTypeEnum.Land]: "Nemovitost",
			},
			PropertyTypeRow: "Druh nemovitosti",
			LandTypeEnum: {
				[ClientPropertyCategoryEnum.Apartment]: "Byt",
				[ClientPropertyCategoryEnum.OnKey]: "Na klíč",
				[ClientPropertyCategoryEnum.LowEnergy]: "Nízká energetická náročnost",
				[ClientPropertyCategoryEnum.Family]: "Rodinný dům",
				[ClientPropertyCategoryEnum.Villa]: "Vila",
				[ClientPropertyCategoryEnum.Garage]: "Garáž",
				[ClientPropertyCategoryEnum.HistoricalObject]: "Historický objekt",
				[ClientPropertyCategoryEnum.Cottage]: "Chata",
				[ClientPropertyCategoryEnum.CivicAmenityBuilding]:
					"Občanská vybavenost",
				[ClientPropertyCategoryEnum.Pond]: "Rybník",
				[ClientPropertyCategoryEnum.Farmstead]: "Statek",
				[ClientPropertyCategoryEnum.OtherBuliding]: "Ostatní stavby",
				[ClientPropertyCategoryEnum.Livving]: "Pro bydlení",
				[ClientPropertyCategoryEnum.CommercialBuilding]:
					"Pro komerční výstavbu",
				[ClientPropertyCategoryEnum.Garden]: "Zahrada",
				[ClientPropertyCategoryEnum.PermanentGrassGrowth]:
					"Trvalý travní porost",
				[ClientPropertyCategoryEnum.Forest]: "Les",
				[ClientPropertyCategoryEnum.AgriculturalLand]: "Zemědělská půda",
				[ClientPropertyCategoryEnum.OtherLand_]: "Ostatní",
				[ClientPropertyCategoryEnum.None]: "Žádný",
			},
			SecondaryBuildingArea: "Plocha vedlejší stavby",
			MarketPriceHistory: "Historie tržní ceny nemovitosti",
			ValueSourceEstimate: "Odhad z {{source}} k {{date}}",
			LandType: "Typ pozemku",
			StreetAndNumber: "Ulice a č. p.",
			Municipality: "Obec",
			ZipCode: "PSČ",
			EstimatedPrice: "Odhadní cena",
			ReproductionPrice: "Reprodukční cena",
			MarketPrice: "Tržní cena",
			CurrentValue: "Aktuální hodnota",
			ForInvestments: "Investiční",
			ParcelNumber: "Číslo parcely",
			ShowParameters: "Zobrazit parametry {{noun}}",
			HideParameters: "Skrýt parametry {{noun}}",
			ParametersNounRealEstate: "nemovitosti",
			ParametersNounVehicle: "vozidla",
			ValueDrawer: {
				updateTitle: "Aktualizovat hodnotu",
				previousValue: "Předchozí hodnota",
				newValueLabel: "Nová hodnota",
				fillTitle: "Doplnit hodnotu",
				confirm: "Uložit",
				savedToast: "Hodnota byla uložena.",
				positiveValue: "Zadejte hodnotu větší než nula.",
				placeholder: "Zadejte částku",
			},
			InteriorPrice: "Hodnota vnitřního vybavení",
			LandPrice: "Hodnota pozemku",
			LandArea: "Plocha pozemku",
			Ownership: "Vlastnictví",
			OwnershipValue: {
				[ClientPropertyOwnershipEnum.Cooperative]: "Družstevní",
				[ClientPropertyOwnershipEnum.DEPRECATED_EMPTY]: "Empty",
				[ClientPropertyOwnershipEnum.National]: "Státní",
				[ClientPropertyOwnershipEnum.NationalMunicipal]: "Státní/obecní",
				[ClientPropertyOwnershipEnum.None]: "Žádné",
				[ClientPropertyOwnershipEnum.Personal]: "Osobní",
				[ClientPropertyOwnershipEnum.Other]: "Jiné",
			},
			BuildingMaterialValue: {
				[ClientPropertyBuildingMaterialEnum.Brick]: "Cihlové",
				[ClientPropertyBuildingMaterialEnum.Custom]: "Jiné",
				[ClientPropertyBuildingMaterialEnum.Empty]: "Prázdné",
				[ClientPropertyBuildingMaterialEnum.Mixed]: "Smíšené",
				[ClientPropertyBuildingMaterialEnum.None]: "Žádné",
				[ClientPropertyBuildingMaterialEnum.Panel]: "Panelové",
				[ClientPropertyBuildingMaterialEnum.ReinforcedConcrete]: "Železobeton",
				[ClientPropertyBuildingMaterialEnum.Skeletal]: "Skeletové",
				[ClientPropertyBuildingMaterialEnum.Stone]: "Kámen",
				[ClientPropertyBuildingMaterialEnum.Wood]: "Dřevostavba",
			},
			Disposition: "Dispozice",
			DispositionValue: {
				[ClientPropertyBuildingDispositionEnum.None]: "Žádná",
				[ClientPropertyBuildingDispositionEnum.OnePlusKK]: "1+kk",
				[ClientPropertyBuildingDispositionEnum.OnePlusOne]: "1+1",
				[ClientPropertyBuildingDispositionEnum.TwoPlusKK]: "2+kk",
				[ClientPropertyBuildingDispositionEnum.TwoPlusOne]: "2+1",
				[ClientPropertyBuildingDispositionEnum.ThreePlusKK]: "3+kk",
				[ClientPropertyBuildingDispositionEnum.ThreePlusOne]: "3+1",
				[ClientPropertyBuildingDispositionEnum.FourPlusKK]: "4+kk",
				[ClientPropertyBuildingDispositionEnum.FourPlusOne]: "4+1",
				[ClientPropertyBuildingDispositionEnum.FivePlusKK]: "5+kk",
				[ClientPropertyBuildingDispositionEnum.FivePlusOne]: "5+1",
				[ClientPropertyBuildingDispositionEnum.SixPlusKK]: "6+kk",
				[ClientPropertyBuildingDispositionEnum.SixPlusOne]: "6+1",
				[ClientPropertyBuildingDispositionEnum.SevenPlusKK]: "7+kk",
				[ClientPropertyBuildingDispositionEnum.SevenPlusOne]: "7+1",
				[ClientPropertyBuildingDispositionEnum.Atypical]: "Atypický",
				[ClientPropertyBuildingDispositionEnum.StudioApartment]: "Garsonka",
				[ClientPropertyBuildingDispositionEnum.Custom]: "Vlastní",
			},
			Floors: "Podlaží",
			NumberOfFloors: "Počet podlaží",
			NumberOfAboveGroundFloors: "Počet nadzemních podlaží",
			BuildingMaterial: "Materiál stavby",
			FloorArea: "Celková podlahová plocha",
			UsableArea: "Užitná plocha",
			Renovation: "Rekonstrukce",
			RenovationValue: {
				[ClientPropertyRenovationEnum.Continuous]: "Průběžná",
				[ClientPropertyRenovationEnum.InProgress]: "Probíhá nebo bude probíhat",
				[ClientPropertyRenovationEnum.None]: "Žádná",
				[ClientPropertyRenovationEnum.Null]: "Null",
				[ClientPropertyRenovationEnum.Total]: "Celková",
				[ClientPropertyRenovationEnum.DEPRECATED_EMPTY]: "Prázdná",
			},
			YearOfRenovation: "Rok rekonstrukce",
			Properties: "Doplňky",
			ApartmentNumber: "Číslo bytové jednotky",
			HouseholdArea: "Plocha domácnosti",
			ItemTitle: "Označení předmětu",
			AdditionalDescription: "Doplňující popis",
			Description: "Popis",
			ArtName: "Název / popis",
			PurchaseDate: "Datum pořízení",
			Value: "Hodnota",
			CarPropertyType: "Druh vozidla",
			CarPropertyTypeValue: {
				[ClientPropertyVehicleTypeEnum.Bus]: "Autobus/minibus",
				[ClientPropertyVehicleTypeEnum.CarUpTo3_5t]: "Osobní automobil",
				[ClientPropertyVehicleTypeEnum.Motorcycle]: "Motocykl/Čtyřkolka",
				[ClientPropertyVehicleTypeEnum.Motorhome]: "Obytný vůz",
				[ClientPropertyVehicleTypeEnum.None]: "Žádný",
				[ClientPropertyVehicleTypeEnum.OtherElectro]:
					"Ostatní vozidla s elektropohonem",
				[ClientPropertyVehicleTypeEnum.OtherVehicles]: "Ostatní vozidla",
				[ClientPropertyVehicleTypeEnum.Tractor]: "Traktor",
				[ClientPropertyVehicleTypeEnum.Trailer]:
					"Přípojné vozidlo (vozík/přívěs)",
				[ClientPropertyVehicleTypeEnum.Truck]: "Nákladní automobil",
				[ClientPropertyVehicleTypeEnum.UtilityCar]: "Užitkový automobil",
				[ClientPropertyVehicleTypeEnum.WorkMachine]: "Pracovní stroj",
			},
			CarBodyType: "Typ karosérie",
			CarBodyTypeValue: {
				[ClientCarBodyTypeEnum.Cabriolet]: "Kabriolet",
				[ClientCarBodyTypeEnum.Combi]: "Kombi",
				[ClientCarBodyTypeEnum.Coupe]: "Coupé",
				[ClientCarBodyTypeEnum.Hatchback]: "Hatchback",
				[ClientCarBodyTypeEnum.Limousine]: "Limuzína",
				[ClientCarBodyTypeEnum.Mpv]: "MPV",
				[ClientCarBodyTypeEnum.None]: "Žádný",
				[ClientCarBodyTypeEnum.OffRoad]: "Terénní",
				[ClientCarBodyTypeEnum.Other]: "Jiná",
				[ClientCarBodyTypeEnum.PickUp]: "Pick-Up",
				[ClientCarBodyTypeEnum.Roadster]: "Roadster",
				[ClientCarBodyTypeEnum.Sedan]: "Sedan",
				[ClientCarBodyTypeEnum.Suv]: "SUV",
				[ClientCarBodyTypeEnum.Van]: "Van",
				[ClientCarBodyTypeEnum.liftback]: "Liftback",
				[ClientCarBodyTypeEnum.DEPRECATED_EMPTY]: "Prázdný",
			},
			CarVehicleType: "Typ vozidla",
			CarVehicleTypeValue: {
				[ClientPropertyCarVehicleTypeEnum.ElectricScooter]:
					"Elektrická koloběžka",
				[ClientPropertyCarVehicleTypeEnum.Empty]: "Prázdný",
				[ClientPropertyCarVehicleTypeEnum.GardenTractor]: "Zahradní traktor",
				[ClientPropertyCarVehicleTypeEnum.GolfCart]: "Golfový vozík",
				[ClientPropertyCarVehicleTypeEnum.Kart]: "Motokára",
				[ClientPropertyCarVehicleTypeEnum.None]: "None",
				[ClientPropertyCarVehicleTypeEnum.Other]: "Ostatní",
				[ClientPropertyCarVehicleTypeEnum.Segway]: "Segway",
			},
			CarLicensePlate: "SPZ",
			CarBrand: "Značka",
			CarModel: "Model",
			CarVin: "VIN",
			CarPurchaseDate: "Datum pořízení",
			CarRegistration: "Datum registrace",
			CreatedAt: "Vyrobeno",
			CarPutIntoService: "Uvedení do provozu",
			CarPower: "Výkon motoru",
			CarVolume: "Objem motoru",
			CarWeight: "Hmotnost",
			CarSeatCount: "Počet míst",
			CarFuelType: "Druh paliva",
			CarFuelTypeValue: {
				[ClientCarFuelEnum.Cng]: "CNG",
				[ClientCarFuelEnum.Diesel]: "Nafta",
				[ClientCarFuelEnum.DieselCng]: "Nafta - CNG",
				[ClientCarFuelEnum.DieselLpg]: "Nafta - LPG",
				[ClientCarFuelEnum.Electricity]: "Elektřina",
				[ClientCarFuelEnum.HybridDiesel]: "Hybrid - nafta",
				[ClientCarFuelEnum.HybridPetrol]: "Hybrid - benzín",
				[ClientCarFuelEnum.Lpg]: "LPG",
				[ClientCarFuelEnum.None]: "None",
				[ClientCarFuelEnum.Other]: "Jiné",
				[ClientCarFuelEnum.Petrol]: "Benzín",
				[ClientCarFuelEnum.PetrolCng]: "Benzín - CNG",
				[ClientCarFuelEnum.PetrolLpg]: "Benzín - LPG",
			},
			CarSecurity: "Zabezpečení",
			CarAlarmSecurity: "Alarm",
			CarActiveTrackingSecurity: "Aktivní sledování",
			CarMechanicalSecurity: "Mechanické zabezpečení",
			CarImmobilizerSecurity: "Imobilizér",
			CarGlassEtchingSecurity: "Značení skel",
			CarPassiveTrackingSecurity: "Pasivní sledování",
			CarSpecialEquipment: "Zvláštní výbava",
			CarSpecialEquipment44: "4x4",
			CarSpecialEquipmentAudiovisualSystem: "Audiovizuální systém",
			CarSpecialEquipmentLeatherUpholstery: "Kožené čalounění",
			CarSpecialEquipmentPanoramicRoof: "Panoramatická střecha",
			CarSpecialEquipmentParkingAssistant: "Parkovací asistent",
			CarValue: "Hodnota vozidla",
			VehicleParameters: "Parametry vozidla",
			Category: "Kategorie",
			CategoryValue: {
				[ClientPropertyCategoryEnum.Apartment]: "Činžovní",
				[ClientPropertyCategoryEnum.OnKey]: "Na klíč",
				[ClientPropertyCategoryEnum.LowEnergy]: "Nízkoenergetický",
				[ClientPropertyCategoryEnum.Family]: "Rodinný",
				[ClientPropertyCategoryEnum.Villa]: "Vila",
				[ClientPropertyCategoryEnum.Garage]: "Garage",
				[ClientPropertyCategoryEnum.HistoricalObject]: "Historical object",
				[ClientPropertyCategoryEnum.Cottage]: "Cottage",
				[ClientPropertyCategoryEnum.CivicAmenityBuilding]:
					"Civic amenity building",
				[ClientPropertyCategoryEnum.Pond]: "Pond",
				[ClientPropertyCategoryEnum.Farmstead]: "Farmstead",
				[ClientPropertyCategoryEnum.OtherBuliding]: "Other building",
				[ClientPropertyCategoryEnum.Livving]: "Living",
				[ClientPropertyCategoryEnum.CommercialBuilding]: "Commercial building",
				[ClientPropertyCategoryEnum.Garden]: "Garden",
				[ClientPropertyCategoryEnum.PermanentGrassGrowth]:
					"Permanent grass growth",
				[ClientPropertyCategoryEnum.Forest]: "Forest",
				[ClientPropertyCategoryEnum.AgriculturalLand]: "Agricultural land",
				[ClientPropertyCategoryEnum.OtherLand_]: "Other land",
				[ClientPropertyCategoryEnum.None]: "Žádná",
			},
			Terrace: "Terasa",
			Loggia: "Lodžie",
			Balcony: "Balkón",
			Garage: "Garáž",
			Cellar: "Sklep",
			Elevator: "Výtah",
			BarrierFree: "Bezbariérový",
			SwimmingPool: "Bazén",
			ParkingSpace: "Parkovací stání",
			Furnished: "Zařízeno",
			YearOfCompletion: "Rok kolaudace",
		},
	},
	Finances: {
		title: "Finanční bilance",
		Intro: {
			title: "Vyplňte svou finanční bilanci",
			description: "Zatím nemáte vyplněné přijmy a výdaje",
			button: "Vyplnit",
			result: "Výsledek",
			surplusTitle: "Využijte tento přebytek",
			surplusDescription:
				"Měsíčně vám zbývá průměrně <balance>{{balance}}</balance>. Tento přebytek je možné dále zhodnotit. Kontaktujte svého poradce a pracujte se svými financemi efektivně.",
			deficitTitle: "Možnosti vyrovnání rozpočtu",
			deficitDescription:
				"Vaše výdaje převyšují příjmy průměrně o <balance>{{balance}}</balance> měsíčně. Kontaktujte svého poradce a najděte společně způsob, jak bilanci zlepšit.",
			contactAdvisor: "Kontaktovat poradce",
		},
		Empty: {
			title: "Zjistěte, kolik vám měsíčně zbývá",
			description: "Vyplnění zabere 5 minut",
			button: "Vyplnit bilanci",
		},
		Detail: {
			result: "Výsledek",
			incomeSection: "Příjmy",
			expensesSection: "Výdaje",
			totalIncome: "Celkové příjmy",
			totalExpenses: "Celkové výdaje",
			editButton: "Upravit bilanci",
		},
		Result: {
			surplusHeading: "Měsíčně vám zbývá",
			deficitHeading: "Měsíčně vám chybí",
			summary: "Souhrn",
			income: "Příjmy",
			expenses: "Výdaje",
			finishButton: "Dokončit",
			checkButton: "Zkontrolovat příjmy a výdaje",
		},
		Recommendation: {
			surplusTitle: "Využijte tento přebytek",
			surplusDescription:
				"Máte měsíční přebytek, který můžete investovat nebo spořit. Kontaktujte svého poradce a proberte možnosti zhodnocení.",
			deficitTitle: "Možnosti vyrovnání rozpočtu",
			deficitDescription:
				"Vaše výdaje přesahují příjmy. Poradce vám pomůže identifikovat oblasti, kde lze ušetřit, a navrhne optimalizaci vašeho rozpočtu.",
			resultSurplusDescription:
				"Máte měsíční přebytek, který můžete investovat nebo spořit.",
			resultDeficitDescription:
				"Vaše výdaje přesahují příjmy. Vyplatí se projít, kde se dá ušetřit.",
			surplusAction: "Jak peníze využít",
			deficitAction: "Probrat s poradcem",
			sent: "Odesláno {{date}}",
		},
		ContactDialog: {
			title: "Kontaktovat poradce",
			description:
				"Proberte s poradcem, jak nejlépe pracovat s výsledkem vaší finanční bilance.",
			button: "Mám zájem",
			successTitle: "Hotovo",
			successDescription: "Požadavek jsme odeslali poradci.",
		},
		Stepper: {
			sumHint: "Součet podrobných položek",
		},
		WhatToCount: {
			title: "Co započítat?",
			readMore: "Číst dále",
			readLess: "Skrýt",
			Income: {
				intro:
					"Pokud máte více různých typů příjmů a chcete je mít všechny přehledně zadané, můžete využít jejich podrobné zadávání",
				categories: [
					{
						title: "Hlavní pravidelný příjem, např.:",
						items: ["mzda", "plat", "příjem z podnikání"],
					},
					{
						title: "Další příjmy, např.:",
						items: [
							"brigády",
							"honoráře",
							"příjmy z dohod",
							"jiné vedlejší činnosti",
						],
					},
					{
						title: "Pasivní příjmy nevyžadují aktivní práci, např.:",
						items: [
							"pronájmy",
							"dividendy",
							"výnosy z investic",
							"licenční poplatky",
						],
					},
					{
						title: "Příjmy od státu, např.:",
						items: [
							"rodičovský příspěvek",
							"důchod",
							"podpora v nezaměstnanosti",
							"jiné sociální dávky",
						],
					},
					{
						title:
							"Ostatní příjmy, které se nevejdou do uvedených kategorií, např.:",
						items: ["výhry", "dary", "příjmy ze zahraničí"],
					},
				],
			},
			Expenses: {
				intro:
					"Pokud máte více různých typů výdajů a chcete je mít všechny přehledně zadané, můžete využít jejich podrobné zadávání.",
				categories: [
					{
						title: "Hlavní pravidelné výdaje, např.:",
						items: ["náklady na domácnost", "bydlení", "dopravu či pojištění"],
					},
					{
						title: "Úspory, např.:",
						items: ["spoření", "investice", "penzijní připojištění"],
					},
					{
						title: "Výdaje na daně, např.:",
						items: ["zálohy na daň z příjmu nebo jiné povinné odvody"],
					},
					{
						title: "Ostatní výdaje, např.:",
						items: [
							"všechny další pravidelné nebo významné výdaje, které nespadají do výše uvedených kategorií",
						],
					},
				],
			},
		},
		Income: {
			titleTentatively: "Měsíční příjmy",
			descriptionTentative:
				"Abychom vám řekli, jakou máte finanční bilanci, potřebujeme znát váš příjem.",
			titleExact: "Zadat podrobně",
			subtitleExact: "Co započítat?",
			sourcesTitle: "Zdroje příjmů",
			addIncome: "Přidat příjem",
			continue: "Pokračovat na výdaje",
		},
		IncomeModal: {
			modalTitle: "Příjem",
			name: "Vlastní název",
			amount: "Částka",
		},
		IncomeSheet: {
			addTitle: "Přidat příjem",
			editTitle: "Příjem",
			name: "Název",
			namePlaceholder: "Např. Mzda, Brigáda...",
			amount: "Měsíční částka",
			add: "Přidat",
		},
		Expenses: {
			titleTentatively: "Měsíční výdaje",
			descriptionTentative:
				"Potřebujeme znát i vaše výdaje, abychom spočítali, kolik vám měsíčně zbývá peněz.",
			titleExact: "Zadat podrobně",
			subtitleExact: "Co započítat?",
			descriptionExact:
				"Pokud máte více různých typů výdajů a chcete je mít všechny přehledně zadané, můžete využít jejich podrobné zadávání.",
			whatToCountDescription:
				"Hlavní pravidelné výdaje – např. náklady na domácnost, bydlení, dopravu či pojištění. Úspory – částky, které pravidelně odkládáte stranou (spoření, investice, penzijní připojištění). Výdaje na daně – např. zálohy na daň z příjmu nebo jiné povinné odvody. Ostatní výdaje – všechny další pravidelné nebo významné výdaje, které nespadají do výše uvedených kategorií.",
			addExpense: "Přidat výdaj",
			minimumValueDescription: "min. výše",
			minimumValueShort: "min.",
			Types: {
				[ClientFinancialPlanExpenseTypeEnum.Household]: {
					title: "Domácnost",
					description:
						"Zadejte pravidelné výdaje spojené s běžným chodem domácnosti – např. potraviny, drogerie, služby (internet) a další nezbytnosti",
				},
				[ClientFinancialPlanExpenseTypeEnum.Housing]: {
					title: "Bydlení",
					description:
						"Zadejte všechny výdaje související s bydlením – např. hypotéka, nájem, služby, spojené s bydlením, energie, fond oprav, údržba.",
				},
				[ClientFinancialPlanExpenseTypeEnum.Insurance]: {
					title: "Pojištění",
					description:
						"Zadejte všechny své platby za životní, majetkové a jiná pojištění, nebo na zdravotní a sociální pojištění (OSVČ).",
				},
				[ClientFinancialPlanExpenseTypeEnum.Saving]: {
					title: "Úspory",
					description:
						"Zadejte částky, které pravidelně odkládáte stranou na spořicí účty, investice, penzijní připojištění nebo jiné formy spoření.",
				},
				[ClientFinancialPlanExpenseTypeEnum.Taxes]: {
					title: "Daně",
					description:
						"Zadejte výdaje související s odvody daní – např. zálohy na daň z příjmu, poplatky za daňového poradce apod.",
				},
				[ClientFinancialPlanExpenseTypeEnum.Traffic]: {
					title: "Doprava",
					description:
						"Zadejte své náklady na dopravu – včetně splátek na auto, pohonných hmot, MHD, pojištění vozidel a servisu.",
				},
				[ClientFinancialPlanExpenseTypeEnum.Other]: {
					title: "Ostatní",
					description:
						"Zadejte všechny další pravidelné nebo významné výdaje, které nespadají do výše uvedených kategorií.",
				},
			},
			Names: {
				[ClientFinancialPlanExpenseNameEnum.Rent]: "Nájemné",
				[ClientFinancialPlanExpenseNameEnum.EnergyBills]: "Energie",
				[ClientFinancialPlanExpenseNameEnum.Fees]: "Poplatky",
				[ClientFinancialPlanExpenseNameEnum.OtherHousing]: "Ostatní",
				[ClientFinancialPlanExpenseNameEnum.Leasing]: "Leasing",
				[ClientFinancialPlanExpenseNameEnum.TollFees]:
					"Dálniční známky a poplatky",
				[ClientFinancialPlanExpenseNameEnum.CarInsurance]: "POV a HAV",
				[ClientFinancialPlanExpenseNameEnum.FuelExpenses]:
					"Výdaje za pohonné hmoty",
				[ClientFinancialPlanExpenseNameEnum.Maintenance]:
					"Údržba, oprava a další",
				[ClientFinancialPlanExpenseNameEnum.Fares]: "Jízdné",
				[ClientFinancialPlanExpenseNameEnum.BuildingSavings]:
					"Stavební spoření",
				[ClientFinancialPlanExpenseNameEnum.PensionProducts]:
					"Penzijní produkty",
				[ClientFinancialPlanExpenseNameEnum.Investments]:
					"Pravidelné investice",
				[ClientFinancialPlanExpenseNameEnum.LifeInsurance]: "Životní",
				[ClientFinancialPlanExpenseNameEnum.HouseholdInsurance]: "Domácnost",
				[ClientFinancialPlanExpenseNameEnum.Responsibility]: "Odpovědnost",
				[ClientFinancialPlanExpenseNameEnum.FoodExpenses]: "Peníze za jídlo",
				[ClientFinancialPlanExpenseNameEnum.PocketMoney]: "Vydané kapesné",
				[ClientFinancialPlanExpenseNameEnum.Hairdressing]: "Kadeřnictví",
				[ClientFinancialPlanExpenseNameEnum.Clothing]: "Oblečení",
				[ClientFinancialPlanExpenseNameEnum.Sport]: "Sport a jiné zájmy",
				[ClientFinancialPlanExpenseNameEnum.Culture]: "Kultura",
				[ClientFinancialPlanExpenseNameEnum.Restaurants]: "Restaurace",
				[ClientFinancialPlanExpenseNameEnum.Pets]: "Domácí mazlíčci",
				[ClientFinancialPlanExpenseNameEnum.Subscription]: "Předplatné",
				[ClientFinancialPlanExpenseNameEnum.Books]: "Knihy, časopisy, noviny",
				[ClientFinancialPlanExpenseNameEnum.MobilePhone]: "Mobilní telefon",
				[ClientFinancialPlanExpenseNameEnum.TuitionFees]: "Školné",
				[ClientFinancialPlanExpenseNameEnum.Gifts]: "Dárky",
				[ClientFinancialPlanExpenseNameEnum.Vacation]: "Dovolená",

				[ClientFinancialPlanExpenseNameEnum.CharityContributions]:
					"Příspěvky na charitu",
				[ClientFinancialPlanExpenseNameEnum.RegularCleaning]:
					"Pravidelný úklid",
				[ClientFinancialPlanExpenseNameEnum.AlimonyPayments]:
					"Placení alimentů",
				[ClientFinancialPlanExpenseNameEnum.Babysitter]: "Chůva",
				[ClientFinancialPlanExpenseNameEnum.Other]: "Jiné",
				[ClientFinancialPlanExpenseNameEnum.Loans]: "Úvěry",
				[ClientFinancialPlanExpenseNameEnum.Cigarettes]: "Cigarety",
				[ClientFinancialPlanExpenseNameEnum.SocialTax]:
					"Sociální, zdravotní, nemocenská",
				[ClientFinancialPlanExpenseNameEnum.IncomeTax]: "Daň z příjmu",
				[ClientFinancialPlanExpenseNameEnum.PropertyTax]: "Daň z nemovitosti",
				[ClientFinancialPlanExpenseNameEnum.Total]: "Celkem",
			},
		},
		ExpensePicker: {
			title: "Výdaje",
			value: "Měsíční platba",
			minimumValue: "Minimální výše",
			description:
				"Zadejte minimální částku, kterou budete muset na tento výdaj dát vždy – i v případě, že se váš příjem sníží.",
		},
		Overview: {
			title: "Výsledek",
			description: "Výsledek vaší finanční bilance je:",
			balancePossitive: "Využijte tento přebytek",
			balancePossitiveDescription:
				"Měsíčně vám zbývá <balance>{{balance}}</balance>. Tento přebytek je možné dále zhodnotit. Kontaktujte svého poradce a pracujte se svými financemi efektivně – např. formou spoření, investic nebo optimalizace finančního plánu.",
			balanceNegative: "Možnosti vyrovnání rozpočtu",
			balanceNegativeDescription:
				"Vaše výdaje převyšují příjmy o <balance>{{balance}}</balance> měsíčně. Kontaktujte svého poradce a najděte společně způsob, jak bilanci zlepšit – např. optimalizací výdajů, sestavením úsporného plánu nebo nalezením dalších řešení.",
			contactAdvisor: "Kontaktovat poradce",
			finishButton: "Dokončit",
			checkButton: "Zkontrolovat příjmy a výdaje",
		},
		SubcategoryPicker: {
			title: "Výdaje",
			allAdded: "V této kategorii už máte zadané všechny položky.",
		},
		ExpenseSheet: {
			value: "Částka",
			minimumValue: "Minimální výše",
			description:
				"Zadejte minimální částku, kterou budete muset na tento výdaj dát vždy – i v případě, že se váš příjem sníží.",
			add: "Přidat",
		},
		Offline: {
			editError: "V offline režimu nelze upravit finanční bilanci.",
			saveError:
				"Uložení se nezdařilo. Zkontrolujte připojení k internetu a zkuste to znovu.",
		},
		LeaveDialog: {
			title: "Neuložené změny",
			description:
				"Opravdu si přejete odejít? Změny ve finanční bilanci zatím nejsou uložené. Uložíte je tlačítkem „Dokončit“ v posledním kroku.",
			leave: "Odejít bez uložení",
			stay: "Pokračovat v úpravách",
		},
		TurnOffDetailDialog: {
			title: "Vypnout podrobné zadání",
			description:
				"Poradce uvidí jen celkovou částku. Jednotlivé položky, které jste zadali, se mu nezobrazí.",
			turnOff: "Vypnout",
			keep: "Ponechat",
		},
	},
	Notifications: {
		title: "Notifikace",
		readAll: "Označit vše za přečtené",
		term: "Termín",
		Tabs: {
			unread: "Nepřečtené",
			all: "Vše",
		},
		Date: {
			today: "Dnes",
			daysAgo: "Před {{count}} dny",
			daysAgo_one: "Včera",
			daysAgo_other: "Před {{count}} dny",
			lastWeek: "Minulý týden",
		},
		noContent: "V tuto chvíli nejsou žádné nepřečtené notifikace",
	},
	NotificationCenter: {
		Title: "Centrum upozornění",
		Tabs: {
			Upcoming: "Nadcházející",
			Recent: "Nedávné",
		},
		Filter: {
			Button: "Filtr",
		},
		Empty: {
			Upcoming: "Žádné nadcházející události ani aktivity",
			Recent: "Zatím žádné uplynulé události ani aktivity",
		},
		EmptyState: {
			Upcoming: {
				title: "Žádné nadcházející události",
				description: "V nejbližší době vás nečekají žádné důležité termíny.",
			},
			Recent: {
				title: "Žádné nedávné události",
				description: "Za posledních 14 dní se nestalo nic důležitého.",
			},
		},
		UpcomingGroups: {
			ResolvingNow: "Právě řešíme",
			In7Days: "Za 7 dní",
			In14Days: "Za 14 dní",
			In30Days: "Za 30 dní",
			In3Months: "Za 3 měsíce",
			In6Months: "Za 6 měsíců",
			In12Months: "Za 12 měsíců",
		},
		RecentGroups: {
			Today: "Dnes",
			ThisWeek: "Tento týden",
			LastWeek: "Minulý týden",
			WeeksAgo: "Před {{count}} týdny",
			WeeksAgo_few: "Před {{count}} týdny",
			WeeksAgo_other: "Před {{count}} týdny",
		},
		Common: {
			Retry: "Zkusit znovu",
			LoadingError: "Načtení selhalo",
			LoadingMore: "Načítám další...",
		},
		FilterScreen: {
			Title: "Filtr",
			HorizonSectionTitle: "Horizont",
			TypeSectionTitle: "Typ",
			Apply: "Použít filtry",
			ResetAriaLabel: "Resetovat filtr",
			Horizon: {
				Month: "Za 30 dní",
				HalfYear: "Za 6 měsíců",
				Year: "Za 12 měsíců",
			},
			Type: {
				All: "Vše",
				Activities: "Aktivity",
				Events: "Události",
				Notifications: "Upozornění",
			},
		},
	},
	DataCard: {
		BasicInfo: {
			title: "Základní údaje",
			additionalInfo: "Doplňující informace",
		},
		Documents: {
			title: "Dokumenty",
		},
		RelatedContracts: {
			title: "Související smlouvy",
		},
		RelatedProperties: {
			title: "Související majetek",
		},
		RelatedServices: {
			title: "Související služby",
		},
		RelatedCard: {
			document: {
				title: "Dokumenty",
				empty:
					"Přiložte smlouvu, potvrzení nebo doklad, budete je mít u této položky po ruce.",
				pin: "Přidat dokument",
				edit: "Upravit dokumenty",
			},
			contract: {
				title: "Související smlouvy",
				empty: "Propojte smlouvy, které spolu souvisí, uvidíte vše pohromadě.",
				pin: "Připnout smlouvu",
				edit: "Upravit propojení",
			},
			property: {
				title: "Související majetek",
				empty: "Propojte majetek, který se k této smlouvě váže.",
				pin: "Připnout majetek",
				edit: "Upravit propojení",
			},
			service: {
				title: "Související služby",
				empty: "Propojte služby navázané na tuto smlouvu.",
				pin: "Připnout službu",
				edit: "Upravit propojení",
			},
		},
		relatedPinToast: "Položka připnuta",
		documentPinUnavailableToast:
			"Přidávání dokumentů připravujeme, brzy bude k dispozici.",
		relatedUnpinToast: "Položka odepnuta",
		PropertyValue: {
			title: "Hodnota nemovitosti",
		},
		PropertyParameters: {
			title: "Parametry nemovitosti",
		},
		Value: {
			title: "Hodnota",
		},
	},
	ExpenseCard: {
		addExpense: "Přidat výdaj",
	},
	Form: {
		Validations: {
			required: "Toto pole je povinné",
			amountPositive: "Zadejte částku větší než 0",
		},
	},
	DocumentDetail: {
		noDocuments: "Žádné dokumenty",
	},
	BarChart: {
		income: "Příjem",
		expenses: "Výdaj",
	},
	Inspiration: {
		disclaimer:
			"Hodnoty jsou orientační a mohou se lišit. Nejedná se o investiční doporučení. Pro přesnou kalkulaci kontaktujte svého finančního poradce.",
		softWarning:
			"Vaše hodnota je netypická, zkontrolujte prosím, zda je to správně.",
		perYear: "p.a.",
		Scenarios: {
			conservative: "Konzervativní",
			balanced: "Vyvážený",
			dynamic: "Dynamický",
		},
		OwnHome: {
			millions: "M",
			category: "Bydlení",
			title: "Vlastní střecha nad hlavou",
			subtitle: "Přestaňte platit cizí hypotéku",
			intro:
				"Platíte nájem a přemýšlíte, jestli vlastní bydlení není nadosah? Ukážeme vám, kolik si můžete dovolit, <b>stačí pár údajů</b>.",
			exampleTitle: "Jak to funguje, příklad",
			exampleBody:
				"Nájem <b>{{rent}}/měs</b> = splátka hypotéky na byt za <blue>~{{property}}</blue>.",
			rentCardLabel: "Po 30 letech v nájmu",
			ownCardLabel: "Po 30 letech vlastního",
			exampleHint: "Spočítáme vám to pro vaši situaci · trvá 30 s",
			cta: "Spočítat pro mě",
			RatesUnavailable: {
				title: "Sazby se nepodařilo načíst",
				description:
					"Bez aktuálních sazeb bankovních partnerů odhad nespočítáme. Zkuste to prosím za chvíli znovu.",
			},
			Sheet: {
				title: "Rychlý odhad",
				description:
					"Tři údaje stačí, abychom spočítali, na co máte nárok. Nic se neukládá, jen orientační odhad.",
				rentLabel: "Měsíční nájem",
				incomeLabel: "Čistý měsíční příjem",
				savingsLabel: "Úspory (volitelné)",
				savingsHint: "Pomůže odhadnout, kolik budete potřebovat na začátku.",
				submit: "Spočítat pro mě",
				saveToBilance: "Uložit do finanční bilance",
			},
			Result: {
				comparisonTitle: "Srovnání nájem vs. vlastní bydlení",
				comparisonText:
					"Platíte <b>{{rent}}</b> měsíčně za nájem. Se stejnou měsíční splátkou byste mohli pořídit byt v dnešní ceně <blue>{{range}}</blue>.",
				comparisonTextWithSavings:
					"Platíte <b>{{rent}}</b> měsíčně za nájem. Se stejnou měsíční splátkou a úsporami <b>{{savings}}</b> byste mohli pořídit byt v dnešní ceně <blue>{{range}}</blue>.",
				comparisonSourceNote: "Dle vámi zadaných údajů.",
				comparisonRentTag: "Nájem",
				comparisonTotalLabel: "Zaplatíte celkem",
				comparisonEndLabel: "Co máte na konci",
				comparisonRentEnd: "Nic",
				comparisonOwnTag: "Vlastní",
				comparisonPropertyLabel: "Hodnota bytu za {{years}} let",
				comparisonHint:
					"Rozpětí vychází ze sazeb našich bankovních partnerů ({{rates}} %) a z růstu cen nemovitostí o 2 až 3 % ročně.",
				comparisonHintExpenses: " Pro přesnější odhad doplňte měsíční výdaje.",
				affordabilityTitle: "Na co dosáhnete",
				edit: "Upravit",
				affordabilityApprox: "Orientační odhad",
				affordabilityExact: "Přesný odhad",
				maxMortgageLabel: "Maximální výše hypotéky",
				rowMaxPayment: "Max. měsíční splátka",
				rowIncome: "Čistý měsíční příjem",
				rowExpenses: "Měsíční výdaje",
				rowCashflow: "Co měsíčně zbyde",
				affordabilityFootnoteApprox:
					"Odhad na základě příjmu. S výdaji bude přesnější.",
				affordabilityFootnoteExact: "Odhad na základě vámi zadaných údajů.",
				affordabilityFootnoteBalance: "Odhad na základě vaší finanční bilance.",
				nudgeExpensesTitle: "Zpřesněte odhad",
				nudgeExpensesText:
					"Doplňte měsíční výdaje a dostanete realističtější odhad podle toho, co vám měsíčně zbyde.",
				downPaymentTitle: "Akontace, kolik potřebujete",
				downPaymentHeading: "Chybí vám ~{{gap}} na vlastní část",
				downPaymentText:
					"Doporučené vlastní peníze 10 % = {{downPayment}}. Máte {{savings}}. Při pravidelném spoření {{monthly}} měsíčně budete připraveni za ~{{years}} let.",
				timelineTitle: "Jak na to",
				createGoal: "Vytvořit cíl „Vlastní bydlení“",
				createGoalSheet: {
					title: "Vytvoříme cíl „Vlastní bydlení“",
					description:
						"Na základě vašich údajů jsme předpočítali startovací hodnoty cíle. Ve formuláři všechno upravíte a doladíte termín.",
					priceLabel: "Cena nemovitosti",
					priceNote:
						"Horní odhad, hypotéka při {{rate}} % + vaše úspory, zaokrouhleno na statisíce",
					loanLabel: "Hypotéka",
					loanNote:
						"Banky obvykle chtějí, abyste ~20 % ceny zaplatili z vlastního",
					savingsLabel: "Vaše úspory",
					savingsNote: "Zadali jste při rychlém odhadu",
					targetLabel: "Zbývá naspořit na vlastní zdroje",
					targetNote: "Cílová částka pro pravidelné spoření do termínu",
					footnote:
						"Hodnoty jsou orientační. Skutečná nabídka banky se může lišit podle vašich příjmů, vybrané nemovitosti a dalších faktorů.",
					continue: "Pokračovat do formuláře",
				},
				contactAdvisor: "Probrat s poradcem",
				advisorMessage:
					"Dobrý den, zajímá mě vlastní bydlení a možnosti financování hypotékou. Můžeme se k tomu spojit?",
				Timeline: {
					prep: {
						title: "Příprava",
						duration: "2–4 týdny",
						desc: "Kolik vám banka půjčí, příprava dokladů",
					},
					search: {
						title: "Hledání nemovitostí",
						duration: "individuální",
						desc: "Prohlídky, rezervační smlouva",
					},
					mortgage: {
						title: "Žádost o hypotéku",
						duration: "2–4 týdny",
						desc: "Poradce porovná nabídky bank",
					},
					approval: {
						title: "Schválení a podpis",
						duration: "1–2 týdny",
						desc: "Podpis smluv, čerpání",
					},
					moving: {
						title: "Stěhování",
						duration: "",
						desc: "Přepis vlastnictví, pojištění",
					},
				},
			},
			ExpensesSheet: {
				title: "Vaše měsíční výdaje",
				description:
					"Výdaje nám řeknou, kolik z příjmu reálně zbyde. Výsledek bude přesnější.",
				sliderLabel: "Měsíční výdaje celkem",
				submit: "Spočítat přesněji",
				saveToBilance: "Uložit do finanční bilance",
			},
			AffordabilitySheet: {
				title: "Upravit údaje",
				description: "Změna kteréhokoliv údaje přepočítá výsledek.",
				incomeLabel: "Čistý měsíční příjem",
				expensesLabel: "Měsíční výdaje",
				submit: "Přepočítat",
			},
		},
		EarlyFreedom: {
			category: "Zabezpečení",
			title: "Finanční nezávislost",
			subtitle: "Až přestanete pracovat, vydělá si majetek sám",
			cta: "Spočítat pro mě",
			intro:
				"Co kdyby vás místo práce živil váš majetek? Spočítáme, <b>kolik si musíte naspořit a kdy to zvládnete</b>, stačí pár čísel.",
			exampleTitle: "Jak to funguje, příklad",
			exampleBody:
				"Chcete utrácet <b>{{spend}}</b> měsíčně. Z pronájmu vám už chodí <b>{{rent}}</b>. Zbývá dorovnat <orange>{{gap}}</orange>, na to si musíte naspořit asi <blue>{{capital}}</blue>.",
			exampleTodayLabel: "Mimo práci dnes",
			exampleNeedLabel: "Potřebujete",
			exampleHint: "Pro vaši situaci to spočítáme za 30 s",
			targetTitle: "Jakou svobodu chcete",
			targetDescription:
				"Kolik byste chtěli mít na měsíc, až nebudete muset pracovat?",
			targetSliderLabel: "Měsíční výdaje",
			passiveTitle: "Příjmy mimo práci",
			edit: "Upravit",
			passiveFullLabel: "Příjem z pronájmu",
			perMonth: "/měs",
			passiveLiteDescription:
				"Máte už příjem z pronájmu? Sníží vám částku, kterou musíte dorovnat.",
			passiveNudgeTitle: "Příjmy mimo práci",
			passiveNudgeText:
				"Řekněte nám, kolik vám měsíčně chodí z pronájmu. Trvá 20 s.",
			capitalTitle: "Kolik si musíte naspořit",
			rowExpenses: "Měsíční výdaje",
			rowPassive: "Mimo práci dnes",
			rowGap: "Zbývá dorovnat",
			capitalLabel: "Potřebujete naspořit",
			capitalNote: "při bezpečném čerpání 4 % ročně",
			capitalDisclaimer:
				"Pronájem už vám vydělává sám, proto ho do tohoto čísla nepočítáme. Jakými investicemi se k této částce dostanete, vyřešíme v dalším kroku.",
			paceTitle: "Vaše tempo k nezávislosti",
			paceSliderLabel: "Měsíční investice",
			paceNow: "Hned",
			paceNever: "—",
			year: "rok",
			year_one: "rok",
			year_few: "roky",
			year_other: "let",
			ageLabel: "vám bude {{age}}",
			paceNote:
				"Výnosy scénářů jsou po inflaci. Konkrétní strategii vám doladí poradce.",
			phasesTitle: "Jak na to",
			readyTitleAlmost: "Jste prakticky finančně nezávislí",
			readyTitleFull: "Jste finančně nezávislí",
			readyKicker: "Finančně nezávislý",
			ReadySteps: {
				drawdown: {
					title: "Spustit čerpání",
					subtitle: "Měsíční rozpočet z výnosů",
				},
				portfolio: {
					title: "Konzervativnější portfolio",
					subtitle: "Stabilita pro nezávislost",
				},
			},
			readyDescAlmost:
				"Pasivní příjem už skoro pokrývá vaše plánované výdaje. Pojďme to s poradcem dotáhnout do konce.",
			readyDescFull:
				"Pasivní příjem už pokrývá vaše plánované výdaje. Projděte to s poradcem, ať to tak i zůstane.",
			contactAdvisor: "Kontaktovat poradce",
			createGoal: "Vytvořit cíl „Finanční nezávislost“",
			discussAdvisor: "Probrat s poradcem",
			advisorMessage:
				"Dobrý den, chci probrat inspiraci „Finanční nezávislost“. Cílová pasivní renta: {{targetIncome}}, potřebný kapitál: {{targetCapital}}, měsíční investice: {{monthlySaving}}, výnosový scénář: {{scenario}} ({{rate}} % p.a.).",
			advisorMessageReady:
				"Dobrý den, chci probrat inspiraci „Finanční nezávislost“. Plánované výdaje: {{targetExpenses}}, pasivní příjem dnes: {{passiveIncome}} ({{coverage}} % pokrytí). Můžeme to dotáhnout do konce?",
			CreateGoalSheet: {
				title: "Vytvoříme cíl „Finanční nezávislost“",
				description:
					"Na základě vašich údajů jsme předpočítali startovací hodnoty cíle. Ve formuláři všechno upravíte a doladíte termín.",
				rentLabel: "Měsíční renta",
				rentNote: "Kolik chcete měsíčně utrácet, až vás uživí majetek",
				rentNoteWithPassive:
					"Cílové výdaje {{expenses}} minus dnešní pasivní příjem {{passive}}",
				dueDateLabel: "Termín",
				dueDateNote: "{{scenario}} scénář se zhodnocením {{rate}} % ročně",
				capitalLabel: "Cílový kapitál",
				capitalNote: "Majetek, ze kterého si rentu vyplácíte (4% pravidlo)",
				footnote:
					"Hodnoty jsou orientační. Skutečný výsledek závisí na vývoji trhů, inflaci a vašich reálných výdajích.",
				continue: "Pokračovat do formuláře",
			},
			QuickSheet: {
				title: "Spočítat pro mě",
				description:
					"Pojďme zjistit, kolik si na to musíte naspořit. Stačí jedno číslo, nic neukládáme.",
				sliderLabel: "Měsíční výdaje",
				hint: "Kolik byste utráceli, kdybyste nemuseli pracovat.",
				submit: "Pojďme na to",
			},
			IncomeSheet: {
				title: "Příjmy mimo práci",
				description: "Sečteme jen to, co vám reálně chodí na účet z pronájmu.",
				sliderLabel: "Příjem z pronájmu",
				hint: "Po odečtení nákladů (daň, údržba, prostoje). Případně si to vezměte z bilance.",
				submit: "Hotovo",
			},
			Anchors: {
				modest: {
					label: "Minimální",
					description: "Domov, jídlo, drobné koníčky",
				},
				comfort: {
					label: "Komfortní",
					description: "Cestování a kvalitní život",
				},
				luxury: { label: "Vlastní", description: "Nastavte si po svém" },
			},
			Phases: {
				diversify: {
					title: "Rozložte zdroje",
					duration: "průběžně",
					desc: "Akcie a fondy, nemovitosti k pronájmu, dluhopisy a penzijko",
				},
				build: {
					title: "Necháváte peníze růst",
					duration: "většinu doby",
					desc: "Víc akcií (70–90 %), výnosy hned znovu investujete",
				},
				approaching: {
					title: "Blížíte se k cíli",
					duration: "posledních 5 let",
					desc: "Postupně přecházíte do bezpečnějších investic a část peněz si držíte jako rezervu na horší roky",
				},
				living: {
					title: "Žijete z toho",
					duration: "",
					desc: "Bezpečnější portfolio a hotovostní rezerva. Když se trhům nedaří, berete si méně, v dobrých letech můžete víc.",
				},
			},
		},
		Retirement: {
			category: "Zabezpečení",
			title: "Důchod podle vašich představ",
			subtitle: "Užijte si penzi tak, jak si zasloužíte",
			cta: "Zadat výdaje do bilance",
			intro:
				"Stát vám v důchodu zaplatí jen část toho, co dnes utrácíte. Spočítáme, <b>kolik si musíte naspořit, abyste si penzi užili podle svých představ</b>. Vyjdeme z vašich výdajů ve finanční bilanci.",
			exampleTitle: "Jak to funguje, příklad",
			exampleBody:
				"Začínáme dnešními výdaji a odečteme, co v důchodu odpadne. Splátky, které do té doby doplatíte, a to, co dnes odkládáte.",
			exampleTodayLabel: "Měsíční výdaje",
			exampleMortgageLabel: "Hypotéka, končí {{year}}",
			exampleSavingsLabel: "Co dnes odkládáte",
			exampleRemainingLabel: "Výdaje v důchodu",
			exampleOutcome:
				"Stát z toho zaplatí <b>~{{state}}</b>, zbývá dorovnat <orange>{{gap}}</orange> měsíčně, tedy naspořit asi <blue>{{capital}}</blue>.",
			exampleHint: "Příklad někoho jiného. U vás to spočítáme z vaší bilance.",
			ageTitle: "Kdy chcete jít do důchodu",
			ageSliderLabel: "Věk odchodu",
			ageValue: "v {{age}} letech ({{year}})",
			ageBound: "{{age}} let",
			ageNote:
				"To je za {{count}} let, v roce {{year}}. Zákonný věk se u mladších ročníků posouvá, počítáme s tím, co jste nastavili.",
			ageNote_one:
				"To je za {{count}} rok, v roce {{year}}. Zákonný věk se u mladších ročníků posouvá, počítáme s tím, co jste nastavili.",
			ageNote_few:
				"To je za {{count}} roky, v roce {{year}}. Zákonný věk se u mladších ročníků posouvá, počítáme s tím, co jste nastavili.",
			ageNote_other:
				"To je za {{count}} let, v roce {{year}}. Zákonný věk se u mladších ročníků posouvá, počítáme s tím, co jste nastavili.",
			expensesTitle: "Co z dnešních výdajů odpadne",
			expensesTodayLabel: "Vaše měsíční výdaje",
			expensesTodayNote: "podle vaší finanční bilance",
			expensesSavingsLabel: "Co dnes odkládáte",
			expensesAddLoan: "Přidat splátku, kterou tu nevidíte",
			expensesRemoveLoan: "Odebrat splátku",
			expensesRemainingLabel: "Odhad výdajů v důchodu",
			expensesNoteEmpty:
				"Nenašli jsme nic, co by v důchodu odpadlo. Doplňte splátky, které v portfoliu chybí, nebo počítáme s celými dnešními výdaji.",
			DropNotes: {
				endsBefore: "končí {{year}}",
				endsAfter: "končí {{year}}, až po odchodu",
				unknownEnd: "neznáme splatnost, neodečítáme",
				savings: "v důchodu čerpáte, nespoříte",
			},
			LoanKinds: {
				HousingLoans: "Hypotéka",
				ConsumerLoans: "Spotřebitelský úvěr",
				Leasing: "Leasing auta",
				OtherLoans: "Jiná splátka",
			},
			targetTitle: "Jaký důchod chcete",
			targetSliderLabel: "Cílový měsíční příjem",
			Anchors: {
				low: "Skromnější",
				mid: "Jako dnes",
				high: "Aktivní",
			},
			stateTitle: "Co dostanete od státu",
			stateAverageNote:
				"Orientační částka, kterou můžete nahradit svým odhadem z ČSSZ.",
			stateCoversAll: "Pokryje celý váš cílový příjem {{income}}.",
			stateCoversShare: "Z vašich cílových {{income}} pokryje {{percent}}.",
			stateFromAge:
				"Až od {{age}} let. Do té doby si důchod platíte celý sami.",
			stateEnterOwn: "Zadat svoje číslo z ČSSZ",
			stateEditOwn: "Upravit svoje číslo",
			perMonth: "/měs",
			capitalTitle: "Kolik si musíte naspořit",
			capitalCoveredTitle: "Váš důchod je pokrytý",
			capitalCoveredNote:
				"<b>Státní důchod vám pokryje celý cílový příjem.</b> Spořit si na něj nemusíte. Zkuste si cíl zvednout, ať vidíte, co by stálo pohodlnější penze.",
			rowIncome: "Cílový příjem",
			rowState: "Stát zaplatí",
			rowGap: "Zbývá dorovnat",
			stageBridgeLabel: "{{from}} až {{to}} let",
			stageBridgeNote: "stát neplatí nic, pokrýváte celý příjem",
			stageStateLabel: "od {{age}} let",
			stageStateNote: "stát dává {{state}}, doplácíte zbytek",
			capitalLabel: "Potřebujete naspořit",
			capitalNoteToZero: "při čerpání po dobu {{years}} let",
			capitalNotePerpetual: "při čerpání {{rate}} ročně",
			capitalAssumptions:
				"Orientační výpočet v dnešních cenách. Počítáme s výnosem {{rate}} ročně po inflaci i během čerpání. Nezohledňuje poplatky ani daně.",
			paceTitle: "Vaše tempo k důchodu",
			paceSliderLabel: "Měsíční příspěvek",
			paceHint: "Podle bilance vám měsíčně zbývá {{amount}}.",
			paceNote:
				"Výnosy scénářů jsou po inflaci. Vyšší výnos znamená i vyšší riziko, konkrétní produkty doladí poradce.",
			paceCoveredFull:
				"<b>Tímto tempem cíl naspoříte celý.</b> Zatím je to jen výpočet. Založte si cíl a začne se to dít.",
			paceCoveredPartial:
				"<b>Tímto tempem naspoříte {{percent}} cíle.</b> Zatím je to jen výpočet. Založte si cíl a začne se to dít.",
			paceShortfall:
				"<b>Tímto tempem naspoříte {{percent}} cíle.</b> Na celý cíl by to chtělo {{required}} měsíčně, tedy o {{gap}} víc.",
			scenarioRecommended: "doporučeno",
			phasesTitle: "Jak na to",
			createGoal: "Vytvořit cíl „Důchod“",
			goalName: "Důchod",
			discussAdvisor: "Probrat s poradcem",
			advisorMessage:
				"Dobrý den, chci si naplánovat důchod podle svých představ. Můžeme to probrat?",
			CreateGoalSheet: {
				title: "Vytvoříme cíl „Důchod“",
				description:
					"Na základě vašich údajů jsme předpočítali startovací hodnoty cíle. Ve formuláři všechno upravíte a doladíte termín.",
				rentLabel: "Renta z vlastních zdrojů",
				rentNote: "Požadovaný příjem {{income}} minus státní důchod {{state}}",
				dueDateLabel: "Termín",
				dueDateNote: "Kdy chcete jít do důchodu ({{age}} let)",
				capitalLabel: "Cílový kapitál",
				capitalNoteToZero:
					"Čerpání po dobu {{years}} let, majetek se postupně spotřebuje",
				capitalNotePerpetual: "Renta navždy, majetek zůstává (4% pravidlo)",
				footnote:
					"Hodnoty jsou orientační. Výše státního důchodu i budoucí výnosy se mohou lišit podle vývoje a vaší situace. Cíl počítá s výnosem {{rate}} ročně, měsíční částka v něm může vyjít jinak.",
				continue: "Pokračovat do formuláře",
			},
			ExpensesSheet: {
				title: "Vaše měsíční výdaje",
				description:
					"Kolik vám měsíčně odejde na běžný život? Uložíme to do vaší finanční bilance a spočítáme z toho celý důchod.",
				sliderLabel: "Měsíční výdaje",
				hint: "Bydlení, jídlo, splátky, doprava. Tedy všechno, co vám pravidelně odchází.",
				submit: "Uložit do bilance",
				openBalance: "Rozepsat celou bilanci",
			},
			AddLoanSheet: {
				title: "Přidat splátku",
				description:
					"Platíte něco, co v portfoliu nemáme? Doplňte to, ať pokrácení výdajů odpovídá skutečnosti.",
				amountLabel: "Měsíční splátka",
				yearLabel: "Splatíte v roce",
				yearHintBefore:
					"Do důchodu ({{year}}) ji stihnete splatit, takže se z výdajů odečte.",
				yearHintAfter:
					"Do důchodu ({{year}}) ji nesplatíte, takže se s ní počítá dál.",
				submit: "Přidat",
			},
			StatePensionSheet: {
				title: "Váš státní důchod",
				description:
					"Výchozích {{amount}} je orientační částka podle průměrného starobního důchodu v Česku, ne váš odhad. Zadejte svoje číslo z ePortálu ČSSZ a výpočet vyjde z něj.",
				sliderLabel: "Státní důchod",
				whereTitle: "Kde ho najdete",
				whereText:
					"Na <b>eportal.cssz.cz</b> v Informativní důchodové aplikaci, položka <b>Odhad starobního důchodu</b>. Je to měsíční částka v dnešních cenách, takže ji sem zadáte beze změny. Přihlásíte se bankovní identitou, Identitou občana nebo datovou schránkou, služba je zdarma.",
				whereNote:
					"Nehledejte Informativní osobní list důchodového pojištění, ten obsahuje jen doby pojištění bez částky. Informativní výpočet starobního důchodu dostanete až 5 let před důchodem.",
				submit: "Hotovo",
			},
			Drawdown: {
				toZero: {
					label: "Důchod na {{years}} let",
					description: "Kapitál postupně utratíte celý. Typický scénář.",
				},
				perpetual: {
					label: "Renta navždy",
					description: "Žijete jen z výnosů. Kapitál zůstane potomkům.",
				},
			},
			Phases: {
				setup: {
					title: "Nastavte penzijko",
					duration: "hned",
					desc: "Plný státní příspěvek získáte v roce {{year}} už od {{amount}} měsíčně.",
				},
				build: {
					title: "Stavíte si majetek",
					duration: "dnes až 5 let před cílem",
					desc: "Investujete vedle penzijka a výnosy hned vracíte zpět.",
				},
				approaching: {
					title: "Blížíte se k důchodu",
					duration: "5 až 1 rok před cílem",
					desc: "Postupně přejdete do bezpečnějších investic a naspoříte si rezervu.",
				},
				living: {
					title: "Žijete z toho",
					duration: "",
					desc: "Berete si postupně, s ohledem na daně. Bezpečnější investice drží hodnotu.",
				},
			},
		},
	},
	Goals: {
		List: {
			title: "Moje cíle",
			activeGoals: "Aktivní cíle",
			completed: "Hotovo",
			ctaTitle: "Máte další sen?",
			ctaTitleCompleted: "Jaký je Váš další plán?",
			ctaDescription: "Řekněte nám, co chcete, a uvidíte cestu k tomu.",
			ctaButton: "Chci nový cíl",
			Status: {
				onTrack: "Na dobré cestě",
				warning: "Potřebuje pozornost",
				offTrack: "Nestíháte",
				unplanned: "Nenaplánováno",
			},
			DueIn: {
				Years: "{{count}} rok",
				Years_one: "{{count}} rok",
				Years_few: "{{count}} roky",
				Years_other: "{{count}} let",
				Months: "{{count}} měsíc",
				Months_one: "{{count}} měsíc",
				Months_few: "{{count}} měsíce",
				Months_other: "{{count}} měsíců",
			},
		},
		EmptyState: {
			title: "Kam míříte?",
			description: "Řekněte, kam míříte, a Váš poradce s Vámi najde cestu.",
			addGoalButton: "Chci si dát cíl",
			getAdviceButton: "Poradit se",
			advisorMessage:
				"Dobrý den, chci si nastavit finanční cíl. Poradíte mi, jak na to?",
			examplesTitle: "Inspirujte se",
			addLabel: "Přidat",
			Examples: {
				Retirement: {
					name: "Finanční svoboda",
					reason: "Až nebudete muset chodit do práce.",
				},
				Housing: {
					name: "Klíče od vlastního",
					reason: "Vlastní střecha nad hlavou.",
				},
				Vacation: {
					name: "Vysněná dovolená",
					reason: "To, co odkládáte už roky.",
				},
			},
		},
		Detail: {
			title: "Můj cíl",
			dueInYear: "Za {{dueIn}} ({{year}})",
			completedInYear: "Splněno {{year}}",
			Blocked: {
				cta: "Napsat poradci",
				advisorMessage: "Chci upravit cíl '{{goal}}'. Požadovaná změna: ",
				Locked: {
					title: "Akce omezena",
					heading: "Tuto akci spravuje váš poradce",
					description:
						"Úpravy tohoto cíle spravuje váš poradce. Pokud chcete změnu, dohodněte se přes chat.",
				},
				Completed: {
					title: "Splněný cíl nelze upravit",
					description:
						"Cíl je označený za splněný, proto je jen pro čtení. Pokud ho chcete upravit, vraťte ho nejdřív mezi aktivní.",
				},
			},
			Actions: {
				ariaLabel: "Akce na cíli",
				complete: "Označit za splněný",
				reactivate: "Vrátit mezi aktivní",
				delete: "Smazat cíl",
				notFoundToast: "Cíl už neexistuje",
				Complete: {
					title: "Označit cíl za splněný?",
					description:
						"Cíl {{name}} se přesune mezi splněné a bude jen pro čtení. Smlouvy k němu zůstanou připnuté. Kdykoli ho můžete vrátit mezi aktivní.",
					confirm: "Označit za splněný",
					cancel: "Zrušit",
					successToast: "Cíl byl označen za splněný",
				},
				Reactivate: {
					title: "Vrátit cíl mezi aktivní?",
					description:
						"Cíl {{name}} se vrátí mezi aktivní. Jeho stav se znovu spočítá podle termínu a připnutých smluv.",
					confirm: "Vrátit mezi aktivní",
					cancel: "Zrušit",
					successToast: "Cíl je zpět mezi aktivními",
				},
			},
			Delete: {
				title: "Smazat cíl?",
				descriptionPrefix: "Opravdu chcete smazat cíl ",
				descriptionSuffix: "? Tuto akci nelze vrátit zpět.",
				confirm: "Smazat cíl",
				cancel: "Ponechat",
				successToast: "Cíl byl smazán",
			},
			WelcomePin: {
				title: "Cíl vytvořen!",
				WithOwnFunds: {
					description:
						"Řekli jste, že máte {{amount}} odloženo bokem. Kde tyto peníze držíte?",
					cta: "Přiřadit peníze bokem",
				},
				WithoutOwnFunds: {
					description:
						"Máte v portfoliu smlouvu, kterou chcete tento cíl plnit?",
					cta: "Ano, vybrat smlouvu",
				},
				dismiss: "Zatím ne",
			},
			Status: {
				onTrack: "Dle plánu",
				warning: "Potřebuje pozornost",
				offTrack: "Nestíháte",
				completed: "Splněno",
				unplanned: "Nenaplánováno",
			},
			OwnFunds: {
				title: "Mám odloženo bokem ({{amount}} Kč)",
				emptyTitle: "Řekněte nám, kde to leží",
				emptyDescription:
					"Připněte spořicí účet, fond nebo kam jinam si tyhle peníze ukládáte.",
				pinContract: "Připnout smlouvu",
				uncovered: "Ještě {{amount}} nemá smlouvu.",
			},
			OwnFundsCallout: {
				title: "Máte už něco bokem?",
				descriptionWithLoan:
					"Přičtěte prostředky k cíli a snížíte si částku ke spoření.",
				descriptionRent:
					"Připojte stávající úspory, penzijko, rezervu nebo investice.",
				descriptionSavings:
					"Přičtěte to, co už máte, a zkrátíte si cestu k cíli.",
				Drawer: {
					title: "Kolik máte bokem?",
					description:
						"Zadejte částku, kterou už máte odloženou stranou. Přičteme ji a snížíte si částku ke spoření.",
					label: "Mám odloženo",
					placeholder: "Např. 500 000",
					submit: "Uložit",
				},
			},
			Solution: {
				title: "Zbývá naspořit ({{amount}} Kč)",
				emptyTitle: "Cíl zatím nemá žádnou smlouvu",
				emptyDescription:
					"Připněte existující smlouvu z portfolia nebo přidejte budoucí.",
				valueLabel: "{{amount}} Kč",
				allocationLabel: "{{percent}} % smlouvy",
				monthlyLabel: "{{amount}}/měs",
				expectedInYear: "→ {{amount}} v {{year}}",
				futureBadge: "Budoucí",
				loanLabel: "Půjčka {{amount}}",
				lumpSumLabel: "{{amount}} jednorázově",
				pinContract: "Připnout smlouvu",
				Actions: {
					detail: "Detail smlouvy",
					updateValue: "Aktualizovat hodnotu",
					editAllocation: "Upravit alokaci",
					editAllocationDescription: "Aktuálně {{percent}} % smlouvy",
					unpin: "Odepnout z cíle",
				},
				Unpin: {
					title: "Odepnout smlouvu",
					description:
						"Smlouva {{name}} zůstane ve vašem portfoliu, jen se přestane počítat na tento cíl.",
					confirm: "Odepnout smlouvu",
					cancel: "Ponechat",
				},
				Allocation: {
					sliderLabel: "Alokace na tento cíl",
					usedOnOther:
						"Na jiných cílech je z této smlouvy alokováno {{usedPercent}} %. Na tento cíl můžete dát maximálně {{maxPercent}} %.",
					previewTitle: "Na tento cíl se počítá",
					valueLabel: "Hodnota",
					outOf: "z {{amount}} Kč",
					submit: "Uložit alokaci",
				},
				Pin: {
					chooseTitle: "Připnout smlouvu",
					chooseDescription:
						"Propojte cíl se smlouvou a uvidíte, jak se k němu blížíte.",
					existingTitle: "Z portfolia",
					existingDescription: "Vybrat stávající smlouvu",
					futureTitle: "Budoucí smlouvu",
					futureDescription: "Poradce Vám pomůže ji sjednat",
					chooseDescriptionSetAside:
						"Kde držíte peníze odložené bokem? Vyberte ze svého portfolia nebo založte novou smlouvu.",
					newTitle: "Nová smlouva",
					newDescription: "Založit v portfoliu a rovnou připnout",
					New: {
						title: "Nová smlouva",
						typeLabel: "Typ",
						nameLabel: "Název smlouvy",
						valueLabel: "Hodnota",
						contractNumberLabel: "Číslo smlouvy",
						producerLabel: "Poskytovatel",
						productLabel: "Produkt",
						showOptional: "Zobrazit nepovinné údaje",
						hideOptional: "Skrýt nepovinné údaje",
						nameHint:
							"Název si zvolte tak, abyste smlouvu poznali, třeba „{{example}}“.",
						NameExamples: {
							BankingProducts: "Spořicí účet Fio",
							BuildingSavings: "Stavebko na rekonstrukci",
							Investments: "Konzervativní fond Conseq",
							PensionProducts: "Penzijko u ČSOB",
						},
						Missing: {
							both: "Doplňte název smlouvy (aspoň 2 znaky) a hodnotu.",
							name: "Název smlouvy musí mít aspoň 2 znaky, ať smlouvu v portfoliu poznáte.",
							value: "Doplňte hodnotu smlouvy.",
						},
						submit: "Přidat do portfolia",
						Help: {
							advisorTitle: "Poradce vám pomůže",
							advisorDescription: "Napište a společně smlouvu založíte.",
							advisorMessage:
								"Dobrý den, k cíli „{{goal}}“ si chci připnout peníze, které mám odložené bokem, ale nevím, kam je v aplikaci zařadit. Můžete mi prosím poradit?",
						},
						Success: {
							drawerTitle: "Hotovo",
							title: "Přidáno do portfolia a připnuto k cíli",
							description:
								"Položka je vidět ve vašem portfoliu a u cíle v sekci Mám odloženo bokem.",
							note: "Váš poradce dostal upozornění a může údaje dovyplnit.",
							backToGoal: "Zpět na cíl",
							fillDetails: "Doplnit další údaje",
						},
					},
					Existing: {
						title: "Vyberte smlouvu",
						noEligible:
							"Ve Vašem portfoliu nejsou žádné smlouvy vhodné pro plnění cíle.",
						hint: "Zobrazujeme jen smlouvy, kterými lze cíl plnit, spoření, investice, penze. U každé vidíte, kolik její kapacity je ještě volné.",
						addNew: "Vložit novou smlouvu",
						fullyAllocated: "Volná kapacita {{percent}} % (min. {{min}} %)",
						attachedGoals: "Drží: {{goals}}",
						attachedGoal: "{{name}} ({{percent}} %)",
						alreadyPinned: "Již připnuto ({{percent}} %), upravit",
						available: "Dostupné {{percent}} %",
					},
					Future: {
						title: "Budoucí smlouva",
						editTitle: "Upravit budoucí smlouvu",
						nameLabel: "Název smlouvy",
						namePlaceholder: "Např. Penzijní spoření",
						typeLabel: "Typ",
						Types: {
							Investment: "Investice",
							Mortgage: "Hypotéka",
							Loan: "Úvěr",
						},
						loanAmountLabel: "Kolik si půjčím",
						loanAmountPlaceholder: "Např. 2 000 000",
						lumpSumLabel: "Jednorázový vklad",
						lumpSumPlaceholder: "Např. 100 000",
						monthlyLabel: "Měsíční částka",
						monthlyPlaceholder: "Např. 5 000",
						startMonthLabel: "Začátek spoření",
						noteLabel: "Poznámka",
						notePlaceholder: "Např. Po dokončení refinancování",
						save: "Přidat budoucí smlouvu",
						saveEdit: "Uložit změny",
						edit: "Upravit",
						delete: "Smazat",
						DeleteConfirm: {
							title: "Smazat budoucí smlouvu",
							description:
								"Plánovaná smlouva {{name}} bude z tohoto cíle odstraněna.",
							confirm: "Smazat smlouvu",
							cancel: "Zrušit",
						},
					},
				},
			},
			LoanCalculator: {
				titleMortgage: "Plánovaná hypotéka ({{amount}} Kč)",
				titleLoan: "Plánovaný úvěr ({{amount}} Kč)",
				descriptionMortgage:
					"Až dospoříte akontaci, začne realizace, zbytek ceny pokryje hypotéka.",
				descriptionLoan:
					"Až dospoříte akontaci, začne realizace, zbytek ceny pokryje úvěr.",
				rateLabel: "Úroková sazba",
				rateValue: "{{rate}} % p.a.",
				rateMin: "2 %",
				rateMax: "8 %",
				termLabel: "Doba splácení",
				termValue: "{{count}} let",
				termValue_one: "{{count}} rok",
				termValue_few: "{{count}} roky",
				termValue_other: "{{count}} let",
				monthlyPayment: "Měsíční splátka",
				monthlyMeta: "při {{rate}} % p.a. · {{term}}",
				totalPaid: "Celkem zaplatíte",
				amountValue: "{{amount}} Kč",
				interest: "Z toho úroky",
				interestValue: "+{{amount}} Kč",
				disclaimer:
					"Orientační výpočet. Konkrétní nabídku připraví poradce podle banky a vaší bonity.",
				showDetail: "Zobrazit detail",
				hideDetail: "Skrýt detail",
			},
			RentPlan: {
				title: "Plán renty",
				phaseAccumulation: "Akumulace",
				phaseDrawdown: "Čerpání",
				accumYearsLabel: "{{count}} let spoření",
				drawdownPerpetualLabel: "{{amount}}/měs věčně",
				drawdownToZeroLabel: "{{years}} let · {{amount}}/měs",
				durationYears: "{{count}} let",
				accumPhaseTitle: "Teď, {{year}}",
				accumPhaseDescription: "Spoříte {{amount}} do startu renty.",
				drawPhaseTitlePerpetual: "{{startYear}}, věčně",
				drawPhaseTitleToZero: "{{startYear}}, {{endYear}}",
				drawPhaseDescriptionPerpetual:
					"Čerpáte {{amount}} měsíčně z úroků. Jistina zůstává jako dědictví.",
				drawPhaseDescriptionToZero:
					"Čerpáte {{amount}} měsíčně, jistinu postupně vyčerpáte do nuly.",
				disclaimer: "Výpočet při reálném výnosu 4 % p.a. po inflaci.",
			},
			ExtraContribution: {
				title: "Co kdybych přidal víc?",
				placeholder: "Pohybujte posuvníkem",
				talkToAdvisor: "Promluvte o tom s poradcem",
				advisorMessage:
					"Dobrý den, zajímá mě navýšení měsíčního příspěvku na cíl „{{goal}}“ o {{extra}}. Můžeme to probrat?",
				otherOptions: "Další možnosti",
				Earlier: {
					label: "Rychlejší splnění",
					subtitle: "{{saved}} dříve",
					today: "Dnes",
					earlier: "dříve",
					years: "{{count}} let",
					years_one: "{{count}} rok",
					years_few: "{{count}} roky",
					years_other: "{{count}} let",
					months: "{{count}} měsíců",
					months_one: "{{count}} měsíc",
					months_few: "{{count}} měsíce",
					months_other: "{{count}} měsíců",
					and: "a",
					none: "0 měsíců",
				},
				More: {
					label: "Naspořte víc",
					subtitle: "+{{amount}} ke splnění",
					originalGoal: "Původní cíl",
					withIncrease: "S navýšením",
					extraToTarget: "+{{amount}} navíc ke splnění",
				},
				Split: {
					label: "Rozdělte chytře",
					subtitle: "{{here}} sem, {{there}} jinam",
					thisGoal: "Tento cíl",
					redirectSurplus: "Přesměrovat přebytek",
					efficient: "Investujete efektivněji do dvou cílů",
					noSplit: "Přidejte víc pro zobrazení návrhu rozdělení",
				},
			},
			Summary: {
				mustHave: "Musím mít",
				alreadySetAside: "({{amount}} už odloženo)",
				thenLoan: "Potom úvěr",
				thenMortgage: "Potom hypotéka",
				setAside: "Odloženo",
				PriceLabels: {
					housing: "Hodnota nemovitosti",
					car: "Cena auta",
					total: "Cena celkem",
					rent: "Celkem budu potřebovat",
				},
				Rent: {
					label: "Renta",
					perpetual: "věčná",
					toZero: "do vyčerpání",
					monthly: "{{amount}}/měs",
					duration: "po {{count}} let",
					duration_one: "po {{count}} rok",
					duration_few: "po {{count}} roky",
					duration_other: "po {{count}} let",
				},
			},
			Composition: {
				title: "Struktura cíle",
				ownFunds: "Vlastní zdroje",
				loan: "Úvěr",
				savings: "Spoření a investice",
				remaining: "Zbývá pokrýt",
				coveredLabel: "pokryto",
			},
			Projection: {
				tileTitle: "Očekávané spoření v {{year}}",
				missing: "Chybí: {{amount}} Kč",
				warningWithCurrent:
					"Jste kousek od plánu. Stačí přidat {{amount}} Kč měsíčně a do {{year}} to zvládnete.",
				warningNoCurrent:
					"S {{amount}} Kč měsíčně navíc to do {{year}} zvládnete.",
				offTrackWithCurrent:
					"Současných {{current}} Kč měsíčně nestačí. Potřebujete aspoň {{needed}} Kč, poradce vám pomůže najít cestu.",
				offTrackNoCurrent:
					"Tenhle cíl zatím nemá žádné spoření. Stačí začít s {{amount}} Kč měsíčně a rozjedete to.",
				rentSource:
					"Vychází z renty {{amount}} Kč/{{frequency}} po {{years}} let",
				Frequency: {
					monthly: "měsíc",
					yearly: "rok",
				},
			},
		},
		Amount: {
			millions: "mil.",
			millionsLetter: "M",
			millionsWord: "milionů",
			millionsWord_one: "milion",
			millionsWord_few: "miliony",
			millionsWord_many: "milionu",
			millionsWord_other: "milionů",
			thousands: "tis.",
			currencySign: "Kč",
		},
		Form: {
			titleCreate: "Nový cíl",
			titleEdit: "Upravit cíl",
			sectionCategory: "Kategorie",
			sectionAbout: "O cíli",
			sectionAmount: "Na kolik to vyjde?",
			nameLabel: "Název cíle",
			namePlaceholder: "Např. Svatba",
			nameMaxLength: "Maximální délka je {{max}} znaků.",
			dueDateLabel: "Termín splnění",
			amountPlaceholder: "Např. 500 000",
			Validations: {
				dueDateTooSoon: "Termín splnění může být nejdříve příští měsíc",
				dueDateTooFar: "Termín splnění může být nejpozději za {{years}} let",
				startDateTooSoon: "Počátek smlouvy může být nejdříve tento měsíc",
				startDateTooFar: "Počátek smlouvy může být nejpozději za {{years}} let",
				amountPositive: "Částka musí být větší než 0",
				amountMax: "Částka může být nejvýše {{max}} {{currency}}",
				rentYearsRange: "Doba čerpání musí být {{min}} až {{max}} let",
			},
			Notices: {
				overpaidTitle: "Zdroje převyšují hodnotu cíle",
				overpaidDescription:
					"Máte o {{excess}} více, než je hodnota cíle. Cíl můžete uložit.",
				statePensionCoversAllTitle: "Státní důchod pokryje celou rentu",
				statePensionCoversAllDescription:
					"Státní důchod {{state}} pokryje celou rentu {{desired}}, takže z vlastních zdrojů nic spořit nemusíte. Cíl nelze uložit. Snižte státní důchod, nebo zvyšte požadovanou rentu.",
			},
			ConfirmEdit: {
				title: "Opravdu si přejete cíl změnit?",
				description: "Váš poradce na tomto cíli pracuje. Změna se mu zobrazí.",
				confirm: "Ano, změnit",
				cancel: "Zrušit",
			},
			SectionTitles: {
				Default: "Cena a financování",
				Housing: "Cena nemovitosti a financování",
				Car: "Cena auta a financování",
				Retirement: "Jak si chcete čerpat rentu?",
				Education: "Kolik chcete mít?",
				Vacation: "Kolik chcete mít?",
			},
			AmountLabels: {
				Default: "Celková cena",
				Housing: "Cena nemovitosti",
				Car: "Cena auta",
				Retirement: "Kolik budu potřebovat",
				Education: "Cílová částka",
				Vacation: "Cílová částka",
			},
			AmountHints: {
				Retirement:
					"Kolik budete v důchodu potřebovat? Zkuste kalkulačku renty, nebo rovnou napište částku.",
				Education:
					"Školné, pomůcky, pobyt: sečtěte vše dohromady. Nemusí to být přesné.",
			},
			OwnFundsLabels: {
				Default: "Mám odloženo bokem",
				Housing: "Mám odloženo bokem",
				Car: "Mám odloženo bokem",
				Education: "Mám odloženo bokem",
				Vacation: "Mám odloženo bokem",
			},
			LoanLabels: {
				Default: "Chci brát úvěr",
				Housing: "Chci brát hypotéku",
				Car: "Chci brát úvěr",
			},
			LoanHints: {
				Default: "Úrokovou sazbu a splátky řešíme v detailu cíle.",
				Housing:
					"Sazbu hypotéky, dobu splácení a splátku si nastavíte až na detailu cíle.",
				Car: "Úrokovou sazbu a splátky řešíme v detailu cíle.",
			},
			RemainingLabels: {
				Default: "Musím naspořit",
				Saving: "Musím naspořit",
			},
			MonthlyConversion: {
				kicker: "Dnes stačí spořit",
				heroSuffix: "Kč měsíčně · 4 % ročně",
				fomo: "Když počkáte rok, bude to <b>{{monthlyDelayed}} Kč měsíčně</b>, o <b>{{extra}} Kč</b> víc.",
				caption: "Přidejte cíl a začněte ho naplňovat ještě dnes.",
			},
			Realization: {
				defaultTitle: "Spořit už nemusíte",
				caption: "Po vytvoření cíle vás nasměřujeme na další kroky.",
				Variants: {
					Home: {
						kicker: "Připraveno k realizaci",
						description:
							"Vlastní zdroje na akontaci máte. Pojďme rovnou na hypotéku a hledání nemovitosti.",
						Steps: {
							preApproval: {
								title: "Předschválení hypotéky",
								subtitle: "Domluvíme s poradcem",
							},
							search: {
								title: "Hledání nemovitosti",
								subtitle: "Tipy a srovnání v Reality Hub",
							},
							documents: {
								title: "Dokumenty pro hypotéku",
								subtitle: "Příjmy, výpisy, identita",
							},
						},
					},
					Car: {
						kicker: "Připraveno k realizaci",
						description:
							"Vlastní zdroje na akontaci máte. Pojďme rovnou na úvěr a výběr auta.",
						Steps: {
							preApproval: {
								title: "Předschválení úvěru",
								subtitle: "Úvěr nebo leasing s poradcem",
							},
							pick: {
								title: "Výběr auta",
								subtitle: "Modely, výbava, financování",
							},
							documents: {
								title: "Dokumenty k úvěru",
								subtitle: "Příjmy, výpisy, identita",
							},
						},
					},
					Retirement: {
						kicker: "Připraveno na důchod",
						description:
							"Naspořeno máte. Pojďme rovnou spustit čerpání důchodu.",
						Steps: {
							start: {
								title: "Spustit čerpání",
								subtitle: "Termín a výše renty s poradcem",
							},
							strategy: {
								title: "Strategie pro důchod",
								subtitle: "Konzervativnější portfolio pro stabilitu",
							},
						},
					},
					Education: {
						kicker: "Připraveno k realizaci",
						description: "Naspořeno máte. Pojďme rovnou s realizací vzdělání.",
						Steps: {
							enroll: {
								title: "Zápis a platba",
								subtitle: "Domluvit termín a uhradit",
							},
							plan: {
								title: "Naplánovat studium",
								subtitle: "Začátek a harmonogram",
							},
						},
					},
					Custom: {
						kicker: "Připraveno k realizaci",
						description: "Naspořeno máte. Cíl je připraven k realizaci.",
						Steps: {
							schedule: {
								title: "Stanovit termín",
								subtitle: "Kdy začnete",
							},
							tasks: {
								title: "První kroky",
								subtitle: "Co je potřeba udělat",
							},
						},
					},
					Vacation: {
						kicker: "Připraveno na cestu",
						description: "Naspořeno máte. Pojďme si naplánovat cestu.",
						Steps: {
							book: {
								title: "Doprava a ubytování",
								subtitle: "Rezervace cesty",
							},
							plan: {
								title: "Pojištění a doklady",
								subtitle: "Cestovní pojištění, víza",
							},
						},
					},
					Rent: {
						kicker: "Připraveno k čerpání",
						description:
							"Naspořeno máte. Pojďme rovnou nastavit čerpání renty.",
						Steps: {
							start: {
								title: "Nastavit čerpání",
								subtitle: "Kdy začít, kolik měsíčně",
							},
							strategy: {
								title: "Investiční strategie",
								subtitle: "Rebalancing pro fázi čerpání",
							},
						},
					},
				},
			},
			Pension: {
				sectionTitle: "Jak si chcete čerpat rentu?",
				Drawdown: {
					toZeroLabel: "Do vyčerpání",
					perpetualLabel: "Nekonečná renta",
				},
				monthlyLabel: "Chci měsíčně",
				monthlyPlaceholder: "Např. 30 000",
				statePensionLabel: "Z toho státní důchod",
				statePensionPlaceholder: "Např. 18 000",
				yearsLabel: "Po dobu",
				yearsPlaceholder: "Např. 20",
				yearsSuffix: "let",
				privateMonthlyLabel: "Z vlastních zdrojů měsíčně",
				privateMonthlyBreakdown: "{{desired}} chci − {{state}} stát",
				totalLabelPerpetual: "Potřebujete mít (věčně)",
				totalLabelToZero: "Potřebujete mít do startu čerpání",
				totalDescriptionPerpetual:
					"Čerpáte pouze reálný výnos, jistina zůstává jako dědictví. Počítáme s reálným výnosem 4 % p.a. po inflaci.",
				totalDescriptionToZero:
					"Jistinu postupně vyčerpáte během {{years}} let. Počítáme s reálným výnosem 4 % p.a. po inflaci.",
				ownFundsLabel: "Mám odloženo bokem",
				ownFundsPlaceholder: "Např. 500 000",
			},
			submitCreate: "Přidat cíl",
			submitEdit: "Uložit",
			cancel: "Zrušit",
			Categories: {
				Housing: "Bydlení",
				Car: "Auto",
				Retirement: "Důchod",
				Rent: "Renta",
				Education: "Vzdělání",
				Vacation: "Dovolená",
				Custom: "Vlastní",
			},
			DefaultNames: {
				Housing: "Pořízení nemovitosti",
				Car: "Nové auto",
				Retirement: "Na důchod",
				Rent: "Pasivní renta",
				Education: "Vzdělání dětí",
				Vacation: "Vysněná dovolená",
			},
		},
	},
	Reminders: {
		Section: {
			title: "Připomenutí",
			addButton: "Přidat připomenutí",
			emptyTitle: "Zatím žádná připomenutí",
		},
		Badge: {
			soon: "Brzy",
			overdue: "Prošlé",
			snoozed: "Odloženo",
			snoozedUntil: "Odloženo do {{date}}",
		},
		Row: {
			subtitle: "do {{date}} · {{recurrence}}",
		},
		Recurrence: {
			Once: "Jednorázově",
			Yearly: "Každý rok",
			Every2Years: "Každé 2 roky",
			Every3Years: "Každé 3 roky",
			Every4Years: "Každé 4 roky",
		},
		Form: {
			addTitle: "Přidat připomenutí",
			editTitle: "Upravit připomenutí",
			addCta: "Přidat připomenutí",
			editCta: "Uložit změny",
			nameLabel: "Název připomenutí",
			namePlaceholder: "Např. Příští platba",
			dateLabel: "Datum připomenutí",
			dateRowLabel: "Datum",
			datePlaceholder: "Vybrat datum",
			recurrenceLabel: "Opakování",
			customTemplate: "Vlastní",
			defaultName: "Připomenutí",
			selectDate: "Vyberte datum",
			duplicateDate: "Na {{date}} už jednu připomínku máte.",
			openExisting: "Otevřít ji",
		},
		Validations: {
			nameRequired: "Zadejte název",
			nameMax: "Maximálně 50 znaků",
			dateRequired: "Vyberte datum",
			dateFuture: "Datum musí být v budoucnosti",
			dateAfterReminder: "Odložení musí být po termínu připomenutí",
		},
		Actions: {
			resolve: "Označit jako vyřešeno",
			snooze: "Odložit",
			edit: "Upravit",
			remove: "Odebrat",
			cancelSnooze: "Zrušit odložení",
		},
		Snooze: {
			title: "Odložit připomenutí",
			tomorrow: "Zítra",
			in3Days: "Za 3 dny",
			in1Week: "Za 1 týden",
			in2Weeks: "Za 2 týdny",
			customDate: "Vlastní datum…",
			confirm: "Odložit",
			until: "Odloží se do {{date}}",
			toast: "Připomenutí odloženo do {{date}}.",
		},
		Resolve: {
			nextScheduledToast: "Příští {{name}} naplánováno na {{date}}.",
			resolvedToast: "Připomenutí je vyřešené.",
		},
		DeleteConfirm: {
			title: "Opravdu smazat připomenutí?",
			description: "{{name}} se smaže a nebude vám chodit upozornění.",
			confirm: "Smazat připomenutí",
			cancel: "Ponechat",
		},
		Templates: {
			Vehicle: {
				stk: "STK",
				service: "Servis",
				insurance: "Pojistka",
				vignette: "Dálniční známka",
				emissions: "Emisní kontrola",
			},
			RealEstate: {
				chimney: "Revize komínu",
				gas: "Revize plynu",
				electrical: "Revize elektroinstalace",
				fireExtinguisher: "Hasicí přístroj",
				propertyTax: "Daň z nemovitosti",
			},
		},
	},
	Auth: {
		LoginForm: {
			offline: "Pracujete v režimu offline.",
		},
	},
	VersionUpdate: {
		modalTitle: "Nová verze aplikace",
		modalContent:
			"Byla nalezena nová verze aplikace. Chcete aplikaci restartovat?",
	},
	Standalone: {
		TabBar: {
			dashboard: "Domů",
			portfolio: "Portfolio",
			dashboardDisabledTooltip:
				"Klient má vypnutý widget Hodnota majetku, náhled na widget je k dispozici až po jeho zapnutí v myDOCK.",
		},
	},
	EventAlert: {
		moreEvents: "Další události ({{count}})",
		dismissAriaLabel: "Skrýt upozornění",
		dontNotify: "Nechci být na tuto událost upozorňován",
		inDays: "za {{count}} dní",
		inDays_one: "za {{count}} den",
		inDays_few: "za {{count}} dny",
		inDays_other: "za {{count}} dní",
		inDaysCapitalized: "Za {{count}} dní",
		inDaysCapitalized_one: "Za {{count}} den",
		inDaysCapitalized_few: "Za {{count}} dny",
		inDaysCapitalized_other: "Za {{count}} dní",
		Actions: {
			contactAdvisor: "Kontaktovat poradce",
			compareRates: "Porovnat sazby",
			renewInsurance: "Obnovit pojistku",
			recalculateInsurance: "Přepočítat pojistku",
			arrangeNew: "Sjednat nové",
			checkConditions: "Zkontrolovat podmínky",
		},
		ActionState: {
			sent: "Odesláno {{date}}",
			lastOpened: "Naposledy otevřeno {{date}}",
		},
		ContactDialog: {
			title: "Kontaktovat poradce",
			description:
				"Odešleme vašemu poradci žádost o kontakt k této smlouvě a co nejdříve se vám ozve.",
			button: "Mám zájem",
			successTitle: "Hotovo",
			successDescription: "Váš požadavek byl odeslán poradci.",
			redesignDescription:
				"Odešleme vašemu poradci žádost o kontakt k této smlouvě.",
			redesignSuccessDescription: "Požadavek jsme odeslali poradci.",
		},
		Content: {
			[EventClassificationEnum.LifeInsuranceEnd]: {
				titleFuture: "Konec smlouvy {{days}}",
				titleToday: "Smlouva vyprší dnes",
				titlePast: "Smlouva vypršela",
				textFuture:
					"{{daysCap}} vyprší vaše životní pojistka. Bez obnovy přijdete o pojistnou ochranu. Doporučujeme jednat s předstihem a konzultovat obnovu s poradcem.",
				textToday:
					"Dnes vyprší vaše životní pojistka. Bez obnovy dojde k zániku pojistné ochrany. Kontaktujte poradce co nejdříve.",
				textPast:
					"Vaše životní pojistka vypršela {{date}}. Pojistná ochrana zanikla. Doporučujeme neprodleně jednat.",
			},
			[EventClassificationEnum.LifeInsuranceAnniversary]: {
				titleFuture: "Výročí pojistky {{days}}",
				titleToday: "Dnes je výročí pojistky",
				titlePast: "Výročí pojistky proběhlo",
				textFuture:
					"{{daysCap}} nastane výročí vaší životní pojistky. Je vhodný čas zkontrolovat, zda podmínky stále odpovídají vaší aktuální životní situaci a potřebám.",
				textToday:
					"Dnes nastalo výročí vaší životní pojistky. Zkontrolujte aktuálnost podmínek a krytí.",
				textPast:
					"Nedávno proběhlo výročí vaší životní pojistky. Zvažte konzultaci podmínek s poradcem.",
			},
			[EventClassificationEnum.HousingLoanEnd]: {
				titleFuture: "Konec smlouvy {{days}}",
				titleToday: "Smlouva vyprší dnes",
				titlePast: "Smlouva vypršela",
				textFuture:
					"{{daysCap}} končí vaše smlouva o hypotečním úvěru. Proberte s poradcem doplacení, refinancování nebo navazující řešení.",
				textToday:
					"Dnes končí vaše smlouva o hypotečním úvěru. Kontaktujte poradce.",
				textPast:
					"Vaše smlouva o hypotečním úvěru skončila. Kontaktujte poradce pro navazující řešení.",
			},
			[EventClassificationEnum.HousingLoanFixationEnd]: {
				titleFuture: "Konec fixace {{days}}",
				titleToday: "Fixace vyprší dnes",
				titlePast: "Fixace skončila",
				textFuture:
					"{{daysCap}} končí vaše fixace úrokové sazby hypotečního úvěru. Po tomto datu se sazba změní na aktuální sazbu banky, pokud nezvolíte novou fixaci nebo nepřefinancujete.",
				textToday:
					"Dnes vyprší vaše fixace úrokové sazby na hypotečním úvěru. Pokud nezvolíte novou fixaci nebo nepřefinancujete, přecházíte na aktuální sazbu banky.",
				textPast:
					"Fixace úrokové sazby hypotečního úvěru vypršela. Jste nyní na aktuální sazbě banky.",
			},
			[EventClassificationEnum.ConsumerLoanEnd]: {
				titleFuture: "Konec smlouvy {{days}}",
				titleToday: "Smlouva vyprší dnes",
				titlePast: "Smlouva vypršela",
				textFuture:
					"{{daysCap}} končí vaše úvěrová smlouva. Proberte s poradcem doplacení nebo navazující řešení.",
				textToday: "Dnes končí vaše úvěrová smlouva. Kontaktujte poradce.",
				textPast:
					"Vaše úvěrová smlouva skončila. Kontaktujte poradce pro navazující řešení.",
			},
			[EventClassificationEnum.LoanEnd]: {
				titleFuture: "Konec smlouvy {{days}}",
				titleToday: "Smlouva vyprší dnes",
				titlePast: "Smlouva vypršela",
				textFuture:
					"{{daysCap}} končí vaše úvěrová smlouva. Kontaktujte poradce, pokud chcete probrat další postup.",
				textToday: "Dnes končí vaše úvěrová smlouva. Kontaktujte poradce.",
				textPast:
					"Vaše úvěrová smlouva skončila. Kontaktujte poradce, pokud řešíte další financování.",
			},
			[EventClassificationEnum.ConsumerLoanFixationEnd]: {
				titleFuture: "Konec fixace {{days}}",
				titleToday: "Fixace vyprší dnes",
				titlePast: "Fixace skončila",
				textFuture:
					"{{daysCap}} vyprší fixace úrokové sazby vašeho úvěru. Po tomto datu může dojít ke změně sazby. Doporučujeme konzultaci s poradcem.",
				textToday:
					"Dnes vyprší fixace úrokové sazby vašeho úvěru. Kontaktujte poradce.",
				textPast:
					"Fixace úrokové sazby úvěru vypršela. Kontaktujte poradce pro nové podmínky.",
			},
			[EventClassificationEnum.PensionEnd]: {
				titleFuture: "Konec smlouvy {{days}}",
				titleToday: "Smlouva vyprší dnes",
				titlePast: "Smlouva vypršela",
				textFuture:
					"{{daysCap}} vyprší vaše penzijní smlouva. Kontaktujte poradce pro instrukce k výplatě, převodu nebo reinvestici naspořených prostředků.",
				textToday:
					"Dnes vyprší vaše penzijní smlouva. Kontaktujte poradce pro instrukce.",
				textPast:
					"Vaše penzijní smlouva vypršela. Kontaktujte poradce pro výplatu nebo reinvestici.",
			},
			[EventClassificationEnum.BuildingSavingsEnd]: {
				titleFuture: "Stavební spoření vyprší {{days}}",
				titleToday: "Stavební spoření vyprší dnes",
				titlePast: "Stavební spoření vypršelo",
				textFuture:
					"{{daysCap}} vyprší vaše stavební spoření. Je čas rozhodnout, zda prostředky vyberete nebo přejdete do úvěrové fáze. Doporučujeme jednat s předstihem a prokonzultovat další postup s poradcem.",
				textToday:
					"Dnes vyprší vaše stavební spoření. Kontaktujte poradce pro výběr prostředků nebo překlop do úvěrové fáze.",
				textPast:
					"Vaše stavební spoření vypršelo. Kontaktujte poradce pro dispozici s naspořenými prostředky.",
			},
			[EventClassificationEnum.InvestmentEnd]: {
				titleFuture: "Konec smlouvy {{days}}",
				titleToday: "Smlouva vyprší dnes",
				titlePast: "Smlouva vypršela",
				textFuture:
					"{{daysCap}} vyprší vaše investiční smlouva. Kontaktujte poradce pro instrukce k dalšímu postupu s investicí.",
				textToday: "Dnes vyprší vaše investiční smlouva. Kontaktujte poradce.",
				textPast:
					"Vaše investiční smlouva vypršela. Kontaktujte poradce pro instrukce.",
			},
			[EventClassificationEnum.BankProductEnd]: {
				titleFuture: "Konec smlouvy {{days}}",
				titleToday: "Smlouva vyprší dnes",
				titlePast: "Smlouva vypršela",
				textFuture:
					"{{daysCap}} vyprší vaše smlouva. Kontaktujte poradce pro obnovu nebo sjednání alternativního bankovního produktu.",
				textToday: "Dnes vyprší vaše smlouva. Kontaktujte poradce.",
				textPast: "Vaše smlouva vypršela. Kontaktujte poradce.",
			},
			[EventClassificationEnum.BusinessLoanEnd]: {
				titleFuture: "Konec smlouvy {{days}}",
				titleToday: "Smlouva vyprší dnes",
				titlePast: "Smlouva vypršela",
				textFuture:
					"{{daysCap}} končí vaše smlouva o podnikatelském úvěru. Kontaktujte poradce, pokud chcete probrat další postup nebo nové financování.",
				textToday:
					"Dnes končí vaše smlouva o podnikatelském úvěru. Kontaktujte poradce.",
				textPast:
					"Vaše smlouva o podnikatelském úvěru skončila. Kontaktujte poradce, pokud řešíte další financování.",
			},
			[EventClassificationEnum.BusinessLoanFixationEnd]: {
				titleFuture: "Konec fixace {{days}}",
				titleToday: "Fixace vyprší dnes",
				titlePast: "Fixace skončila",
				textFuture:
					"{{daysCap}} vyprší fixace úrokové sazby vašeho podnikatelského úvěru. Doporučujeme s předstihem konzultovat podmínky refinancování nebo nové fixace s poradcem.",
				textToday:
					"Dnes vyprší fixace úrokové sazby vašeho podnikatelského úvěru. Kontaktujte poradce.",
				textPast:
					"Fixace podnikatelského úvěru vypršela. Kontaktujte poradce pro nové podmínky.",
			},
			[EventClassificationEnum.RealEstateEnd]: {
				titleFuture: "Konec smlouvy {{days}}",
				titleToday: "Smlouva vyprší dnes",
				titlePast: "Smlouva vypršela",
				textFuture:
					"{{daysCap}} vyprší vaše smlouva na nemovitost. Kontaktujte poradce pro obnovu nebo sjednání nové.",
				textToday: "Dnes vyprší vaše smlouva. Kontaktujte poradce.",
				textPast: "Vaše smlouva vypršela. Kontaktujte poradce.",
			},
			[EventClassificationEnum.CommodityEnd]: {
				titleFuture: "Konec smlouvy {{days}}",
				titleToday: "Smlouva vyprší dnes",
				titlePast: "Smlouva vypršela",
				textFuture:
					"{{daysCap}} vyprší vaše komoditní smlouva. Kontaktujte poradce pro instrukce k dalšímu postupu.",
				textToday: "Dnes vyprší vaše smlouva. Kontaktujte poradce.",
				textPast: "Vaše smlouva vypršela. Kontaktujte poradce.",
			},
			[EventClassificationEnum.ServiceEnd]: {
				titleFuture: "Konec smlouvy {{days}}",
				titleToday: "Smlouva vyprší dnes",
				titlePast: "Smlouva vypršela",
				textFuture:
					"{{daysCap}} vyprší vaše smlouva na službu. Kontaktujte poradce pro obnovu nebo sjednání nové.",
				textToday: "Dnes vyprší vaše smlouva. Kontaktujte poradce.",
				textPast: "Vaše smlouva vypršela. Kontaktujte poradce.",
			},
			[EventClassificationEnum.ServiceAnniversary]: {
				titleFuture: "Výročí smlouvy {{days}}",
				titleToday: "Dnes je výročí smlouvy",
				titlePast: "Výročí smlouvy proběhlo",
				textFuture:
					"{{daysCap}} nastane výročí vaší smlouvy. Je vhodný čas zkontrolovat podmínky a případně přesjednat.",
				textToday:
					"Dnes nastalo výročí vaší smlouvy. Zvažte konzultaci podmínek s poradcem.",
				textPast:
					"Nedávno proběhlo výročí vaší smlouvy. Zvažte konzultaci podmínek.",
			},
			[EventClassificationEnum.CarInsuranceEnd]: {
				titleFuture: "Konec pojistky {{days}}",
				titleToday: "Pojistka vyprší dnes",
				titlePast: "Pojistka vypršela",
				textFuture:
					"Vaše autopojistka vyprší {{days}}. Bez obnovení nesmíte s vozidlem na silnici (POV) nebo přijdete o krytí škod (HAV). Doporučujeme jednat s předstihem.",
				textToday:
					"Dnes vyprší vaše autopojistka. Bez obnovení přijdete o zákonné nebo havarijní krytí. Obnovte pojistku co nejdříve.",
				textPast:
					"Vaše autopojistka vypršela. Momentálně nejste pojištěni. Doporučujeme neprodleně jednat.",
			},
			[EventClassificationEnum.CarInsuranceAnniversary]: {
				titleFuture: "Výročí pojistky {{days}}",
				titleToday: "Výročí pojistky dnes",
				titlePast: "Výročí pojistky proběhlo",
				textFuture:
					"{{daysCap}} nastane výročí vaší autopojistky. Výročí je ideální čas porovnat nabídky trhu a přepočítat pojistné.",
				textToday:
					"Dnes nastalo výročí vaší autopojistky. Využijte příležitost k přepočtu podmínek.",
				textPast:
					"Nedávno proběhlo výročí vaší autopojistky. Zvažte přepočet podmínek s poradcem.",
			},
			[EventClassificationEnum.PropertyInsuranceEnd]: {
				titleFuture: "Obnovení pojistky {{days}}",
				titleToday: "Pojistka vyprší dnes",
				titlePast: "Pojistka vypršela",
				textFuture:
					"Vaše pojistka majetku vyprší {{days}}. Bez obnovení nebude váš majetek pojištěn. Doporučujeme jednat s předstihem.",
				textToday:
					"Dnes vyprší vaše pojistka majetku. Obnovte pojistku co nejdříve pro zachování krytí.",
				textPast:
					"Vaše pojistka majetku vypršela {{date}}. Váš majetek momentálně není pojištěn. Doporučujeme neprodleně jednat.",
			},
			[EventClassificationEnum.PropertyInsuranceAnniversary]: {
				titleFuture: "Výročí pojistky {{days}}",
				titleToday: "Výročí pojistky dnes",
				titlePast: "Výročí pojistky proběhlo",
				textFuture:
					"{{daysCap}} nastane výročí vaší pojistky majetku. Výročí je ideální čas přepočítat podmínky a ověřit, zda pojistná částka stále odpovídá aktuální hodnotě majetku.",
				textToday:
					"Dnes nastalo výročí vaší pojistky majetku. Využijte příležitost k přepočtu podmínek.",
				textPast:
					"Nedávno proběhlo výročí vaší pojistky majetku. Zvažte přepočet podmínek s poradcem.",
			},
			[EventClassificationEnum.TravelInsuranceLongEnd]: {
				titleFuture: "Dlouhodobé cestovní pojištění vyprší {{days}}",
				titleToday: "Cestovní pojištění vyprší dnes",
				titlePast: "Cestovní pojištění vypršelo",
				textFuture:
					"Vaše dlouhodobé cestovní pojištění vyprší {{days}}. Pokud plánujete cestovat, doporučujeme sjednat obnovu s dostatečným předstihem.",
				textToday:
					"Vaše cestovní pojištění dnes vyprší. Sjednejte obnovu pro zachování krytí při cestování.",
				textPast:
					"Vaše dlouhodobé cestovní pojištění vypršelo. Pokud plánujete cestovat, sjednejte nové pojištění.",
			},
			[EventClassificationEnum.TravelInsuranceShortEnd]: {
				titleFuture: "Cestovní pojištění vyprší {{days}}",
				titleToday: "Cestovní pojištění vyprší dnes",
				titlePast: "Cestovní pojištění vypršelo",
				textFuture: "Vaše cestovní pojištění vyprší {{days}}.",
				textToday: "Vaše cestovní pojištění dnes vyprší.",
				textPast:
					"Vaše cestovní pojištění vypršelo. Pokud cestujete, sjednejte nové.",
			},
			[EventClassificationEnum.AccidentHealthInsuranceEnd]: {
				titleFuture: "Konec smlouvy {{days}}",
				titleToday: "Smlouva vyprší dnes",
				titlePast: "Smlouva vypršela",
				textFuture:
					"Vaše pojistka vyprší {{days}}. Kontaktujte poradce pro obnovu nebo sjednání alternativní smlouvy.",
				textToday: "Dnes vyprší vaše pojistka. Kontaktujte poradce.",
				textPast: "Vaše pojistka vypršela. Kontaktujte poradce.",
			},
			[EventClassificationEnum.AccidentHealthInsuranceAnniversary]: {
				titleFuture: "Výročí pojistky {{days}}",
				titleToday: "Výročí pojistky dnes",
				titlePast: "Výročí pojistky proběhlo",
				textFuture:
					"{{daysCap}} nastane výročí vaší pojistky. Zvažte konzultaci podmínek s poradcem.",
				textToday:
					"Dnes nastalo výročí vaší pojistky. Zvažte konzultaci podmínek.",
				textPast:
					"Nedávno proběhlo výročí vaší pojistky. Zvažte konzultaci podmínek.",
			},
			[EventClassificationEnum.LeasingEnd]: {
				titleFuture: "Konec leasingu {{days}}",
				titleToday: "Leasingová smlouva vyprší dnes",
				titlePast: "Leasingová smlouva vypršela",
				textFuture:
					"Váš leasingový kontrakt vyprší {{days}}. Kontaktujte poradce pro instrukce k odkupu vozidla, vrácení nebo sjednání nového leasingu.",
				textToday:
					"Dnes vyprší váš leasingový kontrakt. Kontaktujte poradce pro instrukce.",
				textPast:
					"Váš leasingový kontrakt vypršel. Kontaktujte poradce pro instrukce k dalšímu postupu.",
			},
			[EventClassificationEnum.CryptocurrencyEnd]: {
				titleFuture: "Konec smlouvy {{days}}",
				titleToday: "Smlouva vyprší dnes",
				titlePast: "Smlouva vypršela",
				textFuture:
					"Vaše smlouva na kryptoměny vyprší {{days}}. Kontaktujte poradce pro instrukce.",
				textToday: "Dnes vyprší vaše smlouva. Kontaktujte poradce.",
				textPast: "Vaše smlouva vypršela {{date}}. Kontaktujte poradce.",
			},
		},
	},
};
